// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Allura&family=Cormorant+Garamond:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f1ee;
  color: #2f2a28;
}

img {
  max-width: 100%;
  display: block;
}

button {
  font: inherit;
  cursor: pointer;
}

.navbar {
  background: linear-gradient(180deg, #f7e6eb 0%, #f4dfe7 100%);
  border-bottom: 1px solid rgba(131, 93, 104, 0.12);
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 0.75rem 0 0.5rem;
}

.navbar-keyboard-hidden { display: none; }

.navbar-container {
  max-width: 1460px;
  margin: 0 auto;
  padding: 0 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
}

.brand-block {
  min-width: 220px;
  display: flex;
  align-items: center;
}

.brand-name {
  color: #1a1a1a;
  text-decoration: none;
  font-family: 'Allura', cursive;
  font-size: 2.2rem;
  font-weight: 400;
  letter-spacing: 0.03em;
  line-height: 1;
  white-space: nowrap;
}

.nav-menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  flex: 1 1;
  flex-wrap: wrap;
}

.nav-item {
  position: relative;
  color: #2f2323;
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.05rem;
  font-weight: 600;
  padding: 0.7rem 0.2rem;
  cursor: pointer;
  letter-spacing: 0.02em;
}

.nav-item > a,
.nav-item > span {
  text-decoration: none;
  color: inherit;
}

.nav-disclosure {
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
}

.mobile-nav-toggle {
  display: none;
}

.nav-item:hover > a,
.nav-item:hover > span {
  color: #a6546a;
}

.nav-item:hover .nav-dropdown,
.nav-item.expanded .nav-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.nav-dropdown {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  min-width: 220px;
  background: #fff;
  border: 1px solid #f0e7e2;
  border-radius: 14px;
  box-shadow: 0 18px 35px rgba(67, 41, 41, 0.12);
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition: all 0.2s ease;
  z-index: 20;
}

.mega-dropdown {
  display: flex;
  gap: 1.5rem;
  min-width: 460px;
  padding: 1.25rem;
}

.dropdown-column {
  min-width: 150px;
}

.dropdown-column h4,
.dropdown-card h4 {
  margin-bottom: 0.7rem;
  color: #2f2224;
  font-family: 'Cormorant Garamond', serif;
  font-size: 1rem;
  font-weight: 700;
}

.dropdown-column ul,
.dropdown-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dropdown-column li,
.dropdown-card li {
  color: #554947;
  font-weight: 500;
  font-size: 0.9rem;
}

.dropdown-column li a,
.dropdown-card li a {
  display: block;
  padding: 0.28rem 0.45rem;
  border-radius: 5px;
  color: #554947;
  font-family: 'Cormorant Garamond', serif;
  font-size: 1.02rem;
  font-weight: 500;
  line-height: 1.25;
  text-decoration: none;
  transition: color 160ms ease, background-color 160ms ease;
}

.dropdown-column li a:hover,
.dropdown-column li a:focus-visible,
.dropdown-card li a:hover,
.dropdown-card li a:focus-visible {
  background: #f8e7ec;
  color: #a6546a;
  outline: none;
}

.home-dropdown {
  min-width: 230px;
  padding: 1rem;
}

.dropdown-card p {
  color: #5d4f4d;
  line-height: 1.6;
  margin-bottom: 0.8rem;
}

.contact-dropdown {
  min-width: 240px;
  padding: 1rem;
}

.contact-card {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.contact-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #a6546a;
  font-weight: 700;
  margin: 0.3rem 0;
}

.nav-phone {
  color: #262626;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-family: 'Manrope', sans-serif;
}

.nav-actions {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.icon-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  color: #3f2b21;
  border-radius: 50%;
  transition: background-color 160ms ease, color 160ms ease;
}

.icon-link:hover,
.icon-link:focus-visible {
  color: #a6546a;
  background: rgba(255, 255, 255, 0.65);
  outline: none;
}

.icon-link svg {
  width: 1.55rem;
  height: 1.55rem;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.logout-button {
  border: 1px solid rgba(166, 84, 106, 0.45);
  border-radius: 0.35rem;
  background: transparent;
  color: #8f4057;
  padding: 0.45rem 0.65rem;
  font-size: 0.72rem;
  font-weight: 700;
}

.logout-button:hover { background: rgba(255, 255, 255, 0.65); }
.whatsapp-purpose-note { display: block; margin-top: -0.35rem; margin-bottom: 0.75rem; color: #8f4057; font-size: 0.72rem; line-height: 1.4; }
.same-number-option { display: flex !important; flex-direction: row; align-items: center; gap: 0.5rem; margin-top: 0.6rem !important; margin-bottom: -0.2rem; color: #5f4c49 !important; font-size: 0.78rem !important; font-weight: 600 !important; }
.same-number-option input { width: 1rem; min-height: 1rem; accent-color: #a6546a; }
.phone-input-group { display: grid; grid-template-columns: minmax(9rem, 0.45fr) 1fr; gap: 0.5rem; }
.phone-input-group select { min-width: 0; }

.cart-count {
  position: absolute;
  top: -0.15rem;
  right: -0.2rem;
  min-width: 1.2rem;
  height: 1.2rem;
  padding: 0 0.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #c54078;
  color: #fff;
  font: 700 0.68rem/1 'Manrope', sans-serif;
  border: 2px solid #f5e2e7;
}

.nav-menu .nav-item .nav-dropdown {
  left: 50%;
  transform: translate(-50%, 8px);
}

.nav-menu .nav-item:hover .nav-dropdown {
  left: 50%;
}

.footer {
  background-color: #2c1d27;
  color: #fff;
  padding: 2rem;
  text-align: center;
  margin-top: auto;
}

.home,
.shop,
.product-detail,
.cart,
.checkout,
.contact,
.order-tracking,
.login,
.register {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 2rem;
}

.checkout-page {
  width: min(100% - 2rem, 1040px);
  margin: 0 auto;
  padding: 2.6rem 0 4rem;
}

.checkout-header {
  margin-bottom: 1.3rem;
}

.checkout-header h1 {
  color: #3f2b21;
  font-family: 'Cormorant Garamond', serif;
  font-size: clamp(2.3rem, 5vw, 3.5rem);
  line-height: 1;
  margin-bottom: 0.35rem;
}

.checkout-header p:last-child,
.checkout-note {
  color: #8b7b73;
  font-size: 0.82rem;
}

.checkout-form {
  width: min(100%, 760px);
  padding: 1.55rem 1.6rem;
  border: 1px solid #eee1df;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 12px 36px rgba(70, 43, 35, 0.04);
}

.checkout-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.checkout-section h2,
.checkout-section h3 {
  color: #4a352b;
  font-family: 'Cormorant Garamond', serif;
  margin-bottom: 0.25rem;
}

.checkout-section h2 {
  font-size: 1.45rem;
}

.checkout-section h3 {
  font-family: 'Manrope', sans-serif;
  font-size: 0.88rem;
}

.checkout-form label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  color: #695850;
  font-size: 0.75rem;
}

.checkout-form input,
.checkout-form select {
  width: 100%;
  min-height: 2.55rem;
  padding: 0.65rem 0.75rem;
  border: 1px solid #eadbd9;
  border-radius: 10px;
  background: #fff;
  color: #4b3931;
  outline: none;
}

.checkout-form input:focus,
.checkout-form select:focus {
  border-color: #b9798c;
  box-shadow: 0 0 0 3px rgba(185, 121, 140, 0.12);
}

.checkout-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;
  margin: 0.8rem 0;
}

.checkout-grid > label:last-child:nth-child(3) {
  grid-column: 1 / -1;
}

.delivery-section,
.checkout-rule {
  border-top: 1px solid #eee1df;
  margin-top: 0.8rem;
  padding-top: 1rem;
}

.checkout-note {
  line-height: 1.45;
}

.checkout-total {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.42rem 0;
  color: #6c5b53;
  font-size: 0.85rem;
}

.checkout-total strong {
  color: #4b3931;
}

.checkout-total.total-emphasis {
  border-top: 1px solid #eee1df;
  margin-top: 0.25rem;
  padding-top: 0.75rem;
  font-weight: 700;
  color: #4b3931;
}

.checkout-form > .primary-btn {
  width: 100%;
  margin-top: 0.75rem;
}

.shop-page { width: min(100% - 2rem, 1240px); margin: 0 auto; padding: 2.5rem 0 4rem; }
.shop-header { display: flex; align-items: end; justify-content: space-between; gap: 1rem; margin-bottom: 1.2rem; }
.shop-header h1 { margin-top: .3rem; color: #432d21; }
.shop-header select { width: min(100%, 240px); }
.category-chips { display: flex; gap: .55rem; overflow-x: auto; padding-bottom: 1.3rem; }
.category-chips button { border: 1px solid #eadbd9; border-radius: 999px; padding: .55rem .85rem; background: #fff; color: #654f46; white-space: nowrap; }
.category-chips button.active, .category-chips button:hover { border-color: #a6546a; background: #f8e7ec; color: #8d4058; }

.page-loading,
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  font-size: 1.1rem;
  color: #666;
}

.home-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem 1rem 4rem;
}

.hero-banner {
  min-height: 420px;
  border-radius: 18px;
  padding: 3rem;
  background: linear-gradient(135deg, rgba(255,255,255,0.5), rgba(245,236,232,0.9)),
    url('https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=1400&q=80') center/cover no-repeat;
  display: flex;
  align-items: center;
}

.hero-content {
  max-width: 540px;
  background: rgba(255, 255, 255, 0.52);
  border: 1px solid rgba(171, 126, 107, 0.18);
  backdrop-filter: blur(2px);
  border-radius: 20px;
  padding: 2rem;
}

.eyebrow,
.section-kicker {
  display: inline-block;
  font-size: 0.72rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #bf5570;
  font-weight: 700;
}

.hero-content h1 {
  font-size: clamp(2.2rem, 4vw, 4rem);
  line-height: 1.1;
  margin: 1rem 0;
  color: #2f2a28;
}

.hero-content p {
  font-size: 1.05rem;
  color: #4d3d39;
  line-height: 1.7;
}

.hero-actions {
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.hero-actions button,
.primary-btn,
.secondary-btn,
.whatsapp-btn {
  border: none;
  border-radius: 10px;
  padding: 0.9rem 1.4rem;
  font-weight: 600;
  transition: 0.2s ease;
}

.hero-actions button,
.primary-btn {
  background: #a6546a;
  color: white;
}

.hero-actions .secondary,
.secondary-btn {
  background: transparent;
  border: 1px solid #a6546a;
  color: #a6546a;
}

.products-section {
  margin-top: 3rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.section-header h2 {
  font-size: clamp(2rem, 3vw, 3rem);
  margin-top: 0.5rem;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
}

.product-card {
  background: #fff;
  border: 1px solid #f0e7e2;
  border-radius: 18px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 35px rgba(36, 22, 22, 0.08);
}

.product-image-wrap {
  height: 280px;
  overflow: hidden;
  background: #f6f0ee;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.45s ease;
}

.product-card:hover .product-image {
  transform: scale(1.06);
}

.product-body {
  padding: 1rem;
}

.product-meta {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.7rem;
  flex-wrap: wrap;
}

.badge {
  display: inline-flex;
  align-items: center;
  background: #f3e5e8;
  color: #8d4d5f;
  border-radius: 999px;
  font-size: 0.7rem;
  padding: 0.3rem 0.6rem;
  font-weight: 700;
}

.badge.accent {
  background: #f4d9de;
}

.product-card h3 {
  font-size: 1.15rem;
  margin-bottom: 0.5rem;
}

.product-description {
  color: #5e4f4a;
  font-size: 0.9rem;
  line-height: 1.6;
  min-height: 64px;
}

.product-pricing {
  margin-top: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.price,
.detail-price {
  color: #2d1f24;
  font-weight: 800;
  font-size: 1.2rem;
}

.original-price,
.detail-original {
  color: #8b8b8b;
  text-decoration: line-through;
  font-size: 0.92rem;
}

.product-detail-page {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 2rem 1rem 4rem;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 2.5rem;
}

.product-gallery {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.main-image-wrap {
  background: #fff;
  border: 1px solid #f1e7e3;
  border-radius: 22px;
  padding: 1rem;
}

.main-product-image {
  width: 100%;
  height: 620px;
  object-fit: cover;
  border-radius: 16px;
}

.product-video-wrap {
  background: #fff;
  border: 1px solid #f1e7e3;
  border-radius: 22px;
  padding: 1rem;
}

.product-detail-video {
  display: block;
  width: 100%;
  height: 620px;
  object-fit: cover;
  border-radius: 16px;
  background: #f6f0ee;
}

.thumb-row {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.thumb {
  width: 110px;
  height: 110px;
  border: 2px solid transparent;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  padding: 0;
}

.thumb.active {
  border-color: #bf5570;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  padding-top: 0.5rem;
}

.product-info h1 {
  font-size: clamp(2.1rem, 3vw, 3rem);
  line-height: 1.15;
  margin-bottom: 1rem;
}

.detail-text {
  font-size: 1.02rem;
  line-height: 1.8;
  color: #564c4a;
  margin-bottom: 1.25rem;
}

.price-block {
  display: flex;
  align-items: baseline;
  gap: 0.9rem;
  margin-bottom: 1.5rem;
}

.selector-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  color: #473d3b;
  font-weight: 600;
  margin-bottom: 0.7rem;
}

.text-link {
  border: none;
  background: transparent;
  color: #c3647a;
  font-size: 0.83rem;
}

.size-options {
  display: flex;
  gap: 0.7rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
}

.size-btn {
  border: 1px solid #d8c7bf;
  background: #fff;
  border-radius: 8px;
  padding: 0.7rem 1rem;
  min-width: 110px;
  color: #413a38;
}

.size-btn.selected {
  background: #f5dfe6;
  border-color: #bf5570;
  color: #7b2f46;
  font-weight: 700;
}

.order-note {
  border: 1px solid #f0d7da;
  padding: 0.9rem 1rem;
  border-radius: 12px;
  background: #fff9fa;
  color: #594a4a;
  margin-bottom: 1.25rem;
}

.quantity-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 260px;
  margin-bottom: 1.5rem;
  font-weight: 600;
  color: #3a2d2b;
}

.quantity-box {
  display: inline-flex;
  align-items: center;
  border: 1px solid #d8c7bf;
  border-radius: 10px;
  overflow: hidden;
  background: white;
}

.quantity-box button {
  width: 38px;
  height: 38px;
  border: none;
  background: transparent;
  font-size: 1.3rem;
}

.quantity-box span {
  min-width: 42px;
  text-align: center;
}

.cta-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.primary-btn,
.secondary-btn {
  min-width: 180px;
}

.whatsapp-btn {
  width: 100%;
  background: #effaf3;
  border: 1px solid #bfe0c5;
  color: #2d7c46;
  margin-bottom: 1.5rem;
}

.feature-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
}

.feature-list div {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #524845;
  font-size: 0.84rem;
  border-top: 1px solid #efe5e1;
  padding-top: 1rem;
}

.feature-list strong {
  color: #338f5b;
}

.auth-wrapper {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 1.5rem 1rem 4rem;
}

.auth-card {
  width: min(100%, 760px);
  margin: 0 auto;
  background: #f8f4f1;
  border: 1px solid rgba(150, 106, 87, 0.25);
  border-radius: 26px;
  padding: 2.5rem clamp(1.1rem, 4vw, 2.2rem) 2.1rem;
  box-shadow: 0 18px 30px rgba(101, 75, 58, 0.04);
}

.auth-card h1 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 4rem;
  font-weight: 600;
  color: #3b2a20;
  line-height: 1;
  margin-bottom: 0.75rem;
}

.auth-card > p {
  font-size: 1.2rem;
  color: #4f3f3d;
  font-weight: 400;
  margin-bottom: 1.75rem;
}

.auth-toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8rem;
  background: #e9e3e1;
  border-radius: 14px;
  padding: 0.35rem;
  margin-bottom: 1.8rem;
}

.auth-toggle button {
  background: transparent;
  border: none;
  border-radius: 12px;
  padding: 1rem;
  font-size: 1.1rem;
  color: #574540;
  font-weight: 600;
}

.auth-toggle button.active {
  background: #f5f2f1;
  box-shadow: 0 1px 0 rgba(0,0,0,0.04);
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.auth-form label {
  font-size: 1.05rem;
  color: #3e2c28;
  margin-top: 1.1rem;
  margin-bottom: 0.35rem;
}

.auth-form input {
  width: 100%;
  border: 1px solid rgba(131, 93, 104, 0.3);
  border-radius: 14px;
  background: rgba(255,255,255,0.08);
  padding: 1rem 1rem;
  font-size: 1rem;
  color: #3d2a2a;
  outline: none;
}

.phone-input-group { min-width: 0; }
.phone-input-group input, .phone-input-group select { min-width: 0; }

.auth-form input:focus {
  border-color: #b96e80;
  box-shadow: 0 0 0 2px rgba(185, 110, 128, 0.08);
}

.auth-form input::placeholder { color: #b7adae; opacity: 1; }

.auth-error {
  margin-top: 0.8rem;
  background: #fff3f4;
  border: 1px solid #f1c6ce;
  border-radius: 10px;
  padding: 0.8rem 1rem;
  color: #8d2f3f;
}

.auth-submit {
  margin-top: 1.4rem;
  background: linear-gradient(180deg, #4a2f29 0%, #362821 100%);
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 1rem 1.4rem;
  font-size: 1.1rem;
  font-weight: 700;
}

.auth-bottom-signup {
  display: block;
  margin: 1rem auto 0;
  border: 0;
  background: transparent;
  color: #a6546a;
  font-size: 0.95rem;
  font-weight: 700;
}

.auth-bottom-signup:hover,
.auth-bottom-signup:focus-visible { text-decoration: underline; outline: none; }

.back-home-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 1.8rem auto 0;
  color: #3b2a20;
  text-decoration: none;
  font-size: 1.05rem;
  font-weight: 600;
}

.cart-page {
  max-width: 1280px;
  margin: 3rem auto;
  padding: 0 1.2rem 4rem;
}

.cart-header-block {
  margin-bottom: 2rem;
}

.cart-header-block h1 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 4rem;
  line-height: 1;
  color: #3c2d28;
  margin-bottom: 0.5rem;
}

.cart-header-block p {
  color: #6b5d5a;
  font-size: 1.05rem;
}

.cart-layout {
  display: grid;
  grid-template-columns: minmax(0, 2.2fr) minmax(300px, 1fr);
  gap: 2.2rem;
  align-items: start;
}

.cart-items-panel {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.cart-item-card {
  display: grid;
  grid-template-columns: 170px 1fr auto;
  gap: 1.25rem;
  padding: 1.4rem 1.2rem;
  background: #f9f4f2;
  border: 1px solid rgba(150, 106, 87, 0.24);
  border-radius: 18px;
}

.cart-item-card img {
  width: 170px;
  height: 170px;
  border-radius: 16px;
  object-fit: cover;
}

.cart-item-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
}

.cart-item-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.cart-item-row h3 {
  font-size: 2rem;
  font-family: 'Cormorant Garamond', serif;
  color: #2f2323;
  margin-bottom: 0.25rem;
}

.cart-item-row p {
  color: #645756;
  font-size: 0.95rem;
}

.remove-item {
  border: none;
  background: transparent;
  color: #3a2c2a;
  font-size: 2rem;
  line-height: 1;
}

.cart-item-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.mini-box {
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid rgba(84, 66, 61, 0.32);
}

.mini-box button {
  width: 34px;
  height: 34px;
  font-size: 1.4rem;
}

.cart-item-price {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2a2322;
}

.date-block {
  margin-top: 0.6rem;
}

.date-block h2 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.4rem;
  color: #2f2323;
  margin-bottom: 0.8rem;
}

.date-block p {
  font-size: 1rem;
  line-height: 1.7;
  color: #5c4d48;
  margin-bottom: 1.25rem;
}

.date-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.date-field label {
  color: #473d3d;
  font-weight: 600;
}

.date-field input {
  border: 1px solid rgba(131, 93, 104, 0.25);
  padding: 0.9rem 1rem;
  border-radius: 12px;
  background: rgba(255,255,255,0.08);
  font-size: 1rem;
}

.cart-summary-panel {
  background: #f9f3f1;
  border: 1px solid rgba(150, 106, 87, 0.24);
  border-radius: 18px;
  padding: 1.5rem 1.3rem;
}

.cart-summary-panel h2 {
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.5rem;
  margin-bottom: 1.2rem;
  color: #332725;
}

.summary-row,
.summary-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-size: 1rem;
  padding: 0.7rem 0;
  color: #504544;
}

.summary-row strong,
.summary-total strong {
  font-size: 1.1rem;
  color: #2b2422;
}

.shipping-note {
  font-size: 0.98rem;
  line-height: 1.7;
  color: #5f4c49;
  padding-top: 0.9rem;
  border-top: 1px solid rgba(95, 76, 73, 0.2);
  margin: 0.8rem 0 1.3rem;
}

.summary-total {
  border-top: 1px solid rgba(95, 76, 73, 0.2);
  padding-top: 1rem;
  margin-top: 0.5rem;
}

.summary-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.8rem;
  margin-top: 1.4rem;
}

.summary-actions > button {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
}

.checkout-button {
  border-radius: 14px;
  min-width: 0;
  width: 100%;
}

.summary-whatsapp {
  width: 100%;
  min-width: 0;
  background: #ecf8ef;
  border-color: #8bc59b;
  color: #2c7d46;
  border-radius: 14px;
}

.floating-whatsapp-btn {
  position: fixed;
  right: 28px;
  bottom: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  background: #22a94d;
  border: none;
  color: #ffffff;
  padding: 0.95rem 1.5rem 0.95rem 1rem;
  border-radius: 999px;
  box-shadow: 0 12px 24px rgba(34, 169, 77, 0.3);
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  z-index: 1200;
}

.floating-whatsapp-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}

.floating-whatsapp-icon svg {
  width: 1.45rem;
  height: 1.45rem;
}

.empty-cart-state {
  background: #f9f4f2;
  border: 1px solid rgba(150, 106, 87, 0.24);
  border-radius: 18px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: #594f4c;
}

@media (max-width: 900px) {
  .product-detail-page {
    grid-template-columns: 1fr;
  }

  .main-product-image {
    height: 460px;
  }

  .cart-layout {
    grid-template-columns: 1fr;
  }

  .navbar-container {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.5rem;
  }

  .brand-block {
    grid-column: 1;
    grid-row: 1;
    min-width: 0;
  }

  .brand-name {
    font-size: 2rem;
  }

  .mobile-nav-toggle {
    grid-column: 2;
    grid-row: 1;
    display: inline-grid;
    place-items: center;
    width: 2.75rem;
    height: 2.75rem;
    border: 1px solid rgba(131, 93, 104, 0.25);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
    color: #3f2b21;
    font-size: 1.35rem;
    line-height: 1;
  }

  .nav-menu {
    display: none;
    grid-column: 1 / -1;
    grid-row: 2;
    width: 100%;
    min-width: 0;
    flex: none;
    flex-direction: column;
    align-items: stretch;
    gap: 0.2rem;
    padding-top: 0.45rem;
    border-top: 1px solid rgba(131, 93, 104, 0.18);
  }

  .nav-menu.mobile-open {
    display: flex;
  }

  .nav-item {
    width: 100%;
    padding: 0.35rem 0;
  }

  .nav-disclosure {
    width: 100%;
    min-height: 2.6rem;
    cursor: pointer;
  }

  .nav-dropdown,
  .nav-menu .nav-item .nav-dropdown {
    position: static;
    display: none;
    min-width: 0;
    width: 100%;
    margin-top: 0.25rem;
    padding: 0.65rem 0 0.4rem;
    border: 0;
    border-radius: 0;
    background: rgba(255, 255, 255, 0.45);
    box-shadow: none;
    opacity: 1;
    visibility: visible;
    transform: none;
  }

  .nav-item.expanded .nav-dropdown {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .nav-menu .nav-item .nav-dropdown.mega-dropdown {
    left: auto;
    transform: none;
  }

  .nav-actions {
    position: static;
    align-self: flex-start;
    margin-top: 0.2rem;
  }
}

/* New editorial homepage. Navigation above remains shared with the existing app. */
.new-home {
  --ink: #211a16;
  --muted: #55433e;
  --rose: #94452c;
  --rose-dark: #793019;
  --blush: #fff1eb;
  --cream: #fff8f6;
  --surface: #faebe4;
  --surface-high: #f4e5df;
  --sage: #536251;
  font-family: 'Plus Jakarta Sans', sans-serif;
  background: var(--cream);
  color: var(--ink);
}

.announcement-bar {
  overflow: hidden;
  background: var(--rose);
  color: #fff7f0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  position: relative;
}

.announcement-bar::before,
.announcement-bar::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4rem;
  z-index: 1;
  pointer-events: none;
}

.announcement-bar::before {
  left: 0;
  background: linear-gradient(90deg, var(--rose) 0%, rgba(148, 69, 44, 0));
}

.announcement-bar::after {
  right: 0;
  background: linear-gradient(270deg, var(--rose) 0%, rgba(148, 69, 44, 0));
}

.announcement-track {
  display: inline-flex;
  align-items: center;
  gap: 2.25rem;
  white-space: nowrap;
  min-width: max-content;
  padding: 0.7rem 1rem;
  animation: announcement-marquee 32s linear infinite;
}

.announcement-track span {
  display: inline-block;
  opacity: 0.98;
}

.announcement-track span:nth-child(2n) {
  text-decoration: underline;
}

@keyframes announcement-marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.home-band { width: 100%; }
.new-hero { display: grid; grid-template-columns: minmax(0, 0.9fr) minmax(420px, 1.1fr); gap: clamp(2rem, 5vw, 6rem); align-items: center; padding: clamp(3rem, 7vw, 7rem) max(5vw, 1.25rem); background: linear-gradient(180deg, var(--blush), var(--cream)); border-bottom: 1px solid rgba(136, 114, 108, 0.2); }
.new-hero-copy { max-width: 600px; margin-left: auto; }
.new-kicker { display: inline-block; color: var(--rose); font-size: 0.68rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; }
.new-hero h1 { max-width: 680px; margin: 0.8rem 0 1.2rem; font-family: 'Playfair Display', serif; font-size: clamp(3rem, 5.4vw, 5.25rem); font-weight: 500; line-height: 1.05; letter-spacing: 0; }
.new-hero p { max-width: 510px; color: var(--muted); font-size: 1.05rem; line-height: 1.8; }
.new-actions { display: flex; flex-wrap: wrap; gap: 0.7rem; margin-top: 2rem; }
.new-button { border: 1px solid var(--rose); border-radius: 0.5rem; background: var(--rose); color: #fff; padding: 0.85rem 1.15rem; font-size: 0.78rem; font-weight: 700; letter-spacing: 0.02em; transition: background 160ms ease, transform 160ms ease; }
.new-button:hover { background: var(--rose-dark); transform: translateY(-1px); }
.new-button span { margin-left: 0.45rem; }
.new-button-light { background: transparent; color: var(--rose); }
.hero-proof { display: flex; align-items: center; gap: 0.55rem; margin-top: 1.5rem; color: #8a6b61; font-size: 0.73rem; font-weight: 700; }
.new-hero-media { position: relative; max-width: 700px; overflow: hidden; aspect-ratio: 1 / 0.92; margin-right: auto; background: #dfc5b9; }
.new-hero-media > img { width: 100%; height: 100%; object-fit: cover; }
.hero-product-tag { position: absolute; right: 1rem; bottom: 1rem; left: 1rem; display: grid; grid-template-columns: 1fr auto; gap: 0.2rem 1rem; padding: 0.9rem 1rem; border: 1px solid rgba(136, 114, 108, 0.2); border-radius: 0.75rem; background: rgba(255, 248, 246, 0.95); box-shadow: 0 8px 24px -4px rgba(44, 36, 32, 0.08); }
.hero-product-tag span { grid-column: 1 / -1; color: var(--rose); font-size: 0.62rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; }
.hero-product-tag strong { font-family: 'Playfair Display', serif; font-size: 1.05rem; font-weight: 500; }
.hero-product-tag b { align-self: center; color: var(--rose); font-size: 0.9rem; }
.trust-strip { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 2rem; padding: 2.5rem max(2.75vw, 1.25rem); background: #fcece5; border-top: 1px solid rgba(136, 114, 108, 0.14); border-bottom: 1px solid rgba(136, 114, 108, 0.14); }
.trust-item { display: flex; align-items: center; gap: 1.25rem; min-height: 132px; padding: 1.35rem 1.45rem; border: 1px solid rgba(136, 114, 108, 0.1); border-radius: 1.15rem; background: #fff; box-shadow: 0 3px 7px rgba(44, 36, 32, 0.08); }
.trust-icon { display: grid; place-items: center; flex: 0 0 70px; width: 70px; height: 70px; border-radius: 1rem; color: #91432e; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 2rem; font-weight: 700; line-height: 1; }
.trust-item-fit .trust-icon { background: #ffd9cd; }
.trust-item-fabric .trust-icon { background: #d7e8d1; color: #536251; }
.trust-item-delivery .trust-icon { background: #ffb29c; color: #803a25; }
.trust-item-support .trust-icon { background: #eee4e0; color: #6f625e; }
.trust-item strong, .service-row strong { display: block; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 1.05rem; font-weight: 700; line-height: 1.35; }
.trust-item small, .service-row small { display: block; max-width: 190px; margin-top: 0.25rem; color: #604d47; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 0.93rem; line-height: 1.45; }
.home-section { max-width: 1400px; margin: 0 auto; padding: clamp(3.5rem, 6vw, 6.5rem) max(5vw, 1.25rem); }
.section-heading { display: flex; align-items: end; justify-content: space-between; gap: 2rem; margin-bottom: 2rem; }
.section-heading h2 { margin-top: 0.45rem; font-family: 'Playfair Display', serif; font-size: clamp(2rem, 3.6vw, 3.4rem); font-weight: 500; line-height: 1.08; }
.section-heading p { margin-top: 0.55rem; color: var(--muted); font-size: 0.88rem; }
.text-button { border: 0; background: transparent; color: var(--rose); font-size: 0.78rem; font-weight: 800; white-space: nowrap; }
.category-rail { display: grid; grid-template-columns: repeat(6, minmax(120px, 1fr)); gap: 1rem; }
.category-tile { border: 0; background: transparent; color: var(--ink); text-align: left; }
.category-tile img { width: 100%; aspect-ratio: 0.78; border-radius: 999px 999px 4px 4px; object-fit: cover; margin-bottom: 0.7rem; }
.category-tile strong { display: block; font-family: 'Playfair Display', serif; font-size: 1.05rem; font-weight: 600; }
.category-tile small { display: block; margin-top: 0.2rem; color: var(--muted); font-size: 0.67rem; }
.product-section { max-width: none; background: var(--blush); border-top: 1px solid rgba(136, 114, 108, 0.16); border-bottom: 1px solid rgba(136, 114, 108, 0.16); }
.product-section > * { max-width: 1300px; margin-right: auto; margin-left: auto; }
.new-product-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; }
.new-product-card { cursor: pointer; padding: 0.75rem; border: 1px solid rgba(136, 114, 108, 0.16); border-radius: 1rem; background: #fff; box-shadow: 0 8px 24px -4px rgba(44, 36, 32, 0.04); transition: transform 180ms ease, box-shadow 180ms ease; }
.new-product-card:hover { transform: translateY(-2px); box-shadow: 0 12px 28px -6px rgba(44, 36, 32, 0.12); }
.new-product-image { position: relative; overflow: hidden; aspect-ratio: 0.78; background: #e4d0c5; }
.new-product-image img { width: 100%; height: 100%; object-fit: cover; transition: transform 280ms ease; }
.new-product-card:hover .new-product-image img { transform: scale(1.04); }
.new-product-image > span { position: absolute; top: 0.75rem; left: 0.75rem; padding: 0.3rem 0.5rem; background: #fffaf5; color: var(--rose); font-size: 0.62rem; font-weight: 800; text-transform: uppercase; }
.new-product-image button { position: absolute; top: 0.65rem; right: 0.65rem; width: 2rem; height: 2rem; border: 0; border-radius: 50%; background: #fffaf5; color: var(--rose); }
.new-product-info { padding: 0.8rem 0.15rem; }
.new-product-info small { color: var(--muted); font-size: 0.65rem; text-transform: uppercase; }
.new-product-info h3 { margin: 0.25rem 0; font-family: 'Playfair Display', serif; font-size: 1.1rem; font-weight: 600; }
.new-product-info strong { color: var(--rose); font-size: 0.82rem; }
.bundle-feature { display: grid; grid-template-columns: 1.1fr 0.9fr; align-items: center; gap: clamp(2rem, 6vw, 7rem); background: #fffaf5; }
.bundle-images { display: grid; grid-template-columns: 1.2fr 0.8fr; gap: 0.7rem; align-items: end; }
.bundle-images img { width: 100%; height: 360px; object-fit: cover; }
.bundle-images img + img { height: 250px; }
.bundle-copy { max-width: 470px; }
.bundle-copy h2 { margin: 0.6rem 0 1rem; font-family: 'Playfair Display', serif; font-size: clamp(2.1rem, 3.6vw, 3.5rem); font-weight: 500; line-height: 1.05; }
.bundle-copy p { color: var(--muted); line-height: 1.8; }
.bundle-copy .new-button { display: block; margin-top: 1.4rem; }
.bundle-copy small { display: block; margin-top: 1rem; color: var(--muted); font-size: 0.7rem; }
.moments-section { background: #f7e8df; }
.centered { justify-content: center; text-align: center; }
.moment-grid { display: grid; grid-template-columns: 1.4fr 0.6fr; gap: 1rem; max-width: 1100px; margin: auto; }
.moment-large { position: relative; min-height: 430px; overflow: hidden; background: #cdb1a5; }
.moment-large img { width: 100%; height: 100%; min-height: 430px; object-fit: cover; }
.moment-large > div { position: absolute; right: 1rem; bottom: 1rem; left: 1rem; padding: 1rem; background: rgba(255,250,245,0.9); }
.moment-large small, .moment-note > span { color: var(--rose); font-size: 0.65rem; font-weight: 800; letter-spacing: 0.1em; text-transform: uppercase; }
.moment-large h3, .moment-note h3 { margin-top: 0.35rem; font-family: 'Playfair Display', serif; font-size: 1.6rem; font-weight: 600; line-height: 1.15; }
.moment-note { display: flex; flex-direction: column; justify-content: center; padding: 2rem; background: #fffaf5; }
.moment-note .text-button { align-self: flex-start; margin-top: 2rem; }
.testimonial-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; }
.testimonial-grid blockquote { padding: 1.5rem; background: #f8e9e0; }
.testimonial-grid blockquote > span { color: var(--rose); letter-spacing: 0.15em; }
.testimonial-grid p { margin: 1.5rem 0; color: var(--muted); font-family: 'Playfair Display', serif; font-size: 1.15rem; line-height: 1.35; }
.testimonial-grid footer { font-size: 0.78rem; font-weight: 800; }
.testimonial-grid footer small { display: block; margin-top: 0.25rem; color: var(--muted); font-weight: 500; }
.offer-section { max-width: 920px; margin-top: 3rem; margin-bottom: 3rem; background: #f8e9e0; text-align: center; }
.offer-icon { display: grid; place-items: center; width: 2.3rem; height: 2.3rem; margin: 0 auto 1rem; border-radius: 50%; background: #fffaf5; color: var(--rose); }
.offer-section h2 { margin: 0.55rem 0; font-family: 'Cormorant Garamond', serif; font-size: clamp(2rem, 4vw, 3.5rem); font-weight: 500; }
.offer-section p { margin-bottom: 1.2rem; color: var(--muted); }
.service-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; padding: 2rem max(5vw, 1.25rem); background: #fffaf5; }
.service-row > div { display: flex; gap: 0.7rem; align-items: center; }

.contact-page { max-width: 1180px; margin: 0 auto; padding: 5rem max(5vw, 1.25rem) 7rem; }
.contact-hero { max-width: 720px; padding-bottom: 3rem; }
.contact-hero h1 { margin: 0.5rem 0 1rem; font-family: 'Playfair Display', serif; font-size: clamp(2.8rem, 6vw, 5.5rem); font-weight: 500; line-height: 1; }
.contact-hero > p:last-child { max-width: 580px; color: var(--muted); font-size: 1.05rem; line-height: 1.8; }
.contact-details-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; gap: 1rem; }
.contact-detail-card { padding: 2rem; border: 1px solid rgba(136, 114, 108, 0.2); border-radius: 1rem; background: #fffaf7; box-shadow: 0 10px 28px rgba(82, 57, 48, 0.06); }
.contact-card-kicker { color: var(--rose); font-size: 0.68rem; font-weight: 800; letter-spacing: 0.14em; text-transform: uppercase; }
.contact-detail-card h2 { margin: 0.7rem 0 1.2rem; font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.2rem); font-weight: 500; }
.contact-detail-card address { color: var(--muted); font-style: normal; line-height: 1.8; }
.contact-action { display: inline-flex; align-items: center; justify-content: center; margin-top: 1.5rem; padding: 0.75rem 1rem; border: 1px solid var(--rose); border-radius: 0.45rem; color: var(--rose); font-size: 0.82rem; font-weight: 800; text-decoration: none; }
.contact-action:hover { background: var(--rose); color: #fff; }

.account-page { max-width: 1180px; margin: 0 auto; padding: 4rem max(5vw, 1.25rem) 6rem; }
.account-header { padding-bottom: 2rem; border-bottom: 1px solid rgba(136, 114, 108, 0.2); }
.account-header h1 { margin: 0.45rem 0; font-family: 'Playfair Display', serif; font-size: clamp(2.5rem, 5vw, 4.5rem); font-weight: 500; }
.account-header > p:last-child { color: var(--muted); }
.account-section { margin-top: 2rem; }
.account-section h2 { margin-bottom: 0.8rem; font-family: 'Playfair Display', serif; font-size: 2rem; font-weight: 500; }
.account-section > p { color: var(--muted); line-height: 1.6; }
.account-contact-form { display: grid; grid-template-columns: minmax(0, 1fr); gap: 1rem; max-width: 760px; padding: 1.35rem; border: 1px solid rgba(136, 114, 108, 0.18); border-radius: 0.9rem; background: rgba(255, 250, 247, 0.78); box-shadow: 0 10px 28px rgba(82, 57, 48, 0.06); }
.account-contact-form label { display: grid; gap: 0.4rem; color: var(--muted); font-size: 0.78rem; font-weight: 700; }
.account-contact-form input, .account-contact-form select { width: 100%; min-height: 3.25rem; }
.account-contact-actions { display: flex; flex-wrap: wrap; gap: 0.65rem; grid-column: 1 / -1; }
.account-contact-summary { display: grid; grid-template-columns: minmax(0, 1fr); align-items: center; gap: 1.1rem; max-width: 760px; padding: 1.35rem; border: 1px solid rgba(136, 114, 108, 0.18); border-radius: 0.9rem; background: rgba(255, 250, 247, 0.78); box-shadow: 0 10px 28px rgba(82, 57, 48, 0.06); }
.account-contact-summary span, .account-contact-summary strong { display: block; }
.account-contact-summary span { color: var(--rose); font-size: 0.65rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; }
.account-contact-summary strong { display: block; margin-top: 0.35rem; font-size: 0.95rem; }
.account-contact-summary button { white-space: nowrap; }
.contact-update-message { grid-column: 1 / -1; color: #3c7a4a; font-size: 0.8rem; }
.account-order-list { display: grid; gap: 1rem; }
.account-order { padding: 1.25rem; border: 1px solid rgba(136, 114, 108, 0.2); border-radius: 0.8rem; background: #fffaf7; }
.account-order-header, .account-order-footer { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }
.account-order-header { padding-bottom: 1rem; border-bottom: 1px solid rgba(136, 114, 108, 0.16); }
.account-order-header strong, .account-order-header small { display: block; }
.account-order-label { display: block; color: var(--rose); font-size: 0.65rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; }
.account-order-header small { margin-top: 0.25rem; color: var(--muted); font-size: 0.75rem; }
.order-status { padding: 0.35rem 0.65rem; border-radius: 999px; background: #f0e5d9; color: #6d5143; font-size: 0.7rem; font-weight: 800; text-transform: capitalize; }
.order-status-delivered { background: #dcebd8; color: #4d7047; }
.order-status-cancelled, .order-status-returned { background: #f3dada; color: #8b4444; }
.account-order-items { display: grid; gap: 0.75rem; padding: 1rem 0; }
.account-order-item { display: grid; grid-template-columns: 58px 1fr auto; align-items: center; gap: 0.8rem; }
.account-order-item img, .account-order-image-placeholder { width: 58px; height: 70px; border-radius: 0.35rem; object-fit: cover; background: #ead6d0; }
.account-order-image-placeholder { display: grid; place-items: center; color: var(--rose); font-family: 'Allura', cursive; font-size: 1.5rem; }
.account-order-item-info strong, .account-order-item-info span { display: block; }
.account-order-item-info strong { font-family: 'Playfair Display', serif; font-size: 1.05rem; }
.account-order-item-info span, .account-order-item b, .account-order-footer { color: var(--muted); font-size: 0.78rem; }
.account-order-item b, .account-order-footer strong { color: var(--ink); }
.account-order-footer { padding-top: 0.9rem; border-top: 1px solid rgba(136, 114, 108, 0.16); }
.field-help { display: block; margin-top: 0.45rem; color: var(--muted); font-size: 0.72rem; line-height: 1.45; }
.field-help-alert { color: #c43d4f; font-weight: 700; animation: address-alert-flicker 700ms ease-in-out 2; }
.combo-measurement-notice { margin: 0.8rem 0; color: #c43d4f; font-weight: 800; line-height: 1.45; animation: address-alert-flicker 700ms ease-in-out 6; }
@keyframes address-alert-flicker {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.18; }
}

@media (max-width: 900px) {
  .new-hero, .bundle-feature { grid-template-columns: 1fr; }
  .new-hero-copy { margin: 0; }
  .new-hero-media { width: 100%; }
  .category-rail { display: flex; overflow-x: auto; padding-bottom: 0.7rem; scroll-snap-type: x mandatory; }
  .category-tile { flex: 0 0 145px; scroll-snap-align: start; }
  .new-product-grid { grid-template-columns: repeat(2, 1fr); }
  .bundle-copy { max-width: none; }
  .service-row { grid-template-columns: repeat(2, 1fr); }
  .trust-strip { gap: 1rem; padding: 1.5rem 1rem; }
  .trust-item { gap: 0.75rem; min-height: 110px; padding: 1rem; }
  .trust-icon { flex-basis: 54px; width: 54px; height: 54px; border-radius: 0.85rem; font-size: 1.55rem; }
  .trust-item strong { font-size: 0.85rem; }
  .trust-item small { font-size: 0.72rem; }
}

@media (max-width: 600px) {
  .contact-page { padding-top: 3rem; }
  .contact-details-grid { grid-template-columns: 1fr; }
  .contact-detail-card { min-height: 0; padding: 1.4rem; }
  .contact-detail-card h2 { font-size: 1.8rem; }
  .account-page { padding-top: 2.5rem; }
  .account-contact-form { grid-template-columns: 1fr; padding: 1rem; }
  .account-contact-summary { grid-template-columns: 1fr; align-items: start; padding: 1rem; }
  .account-order { padding: 1rem; }
  .account-order-header, .account-order-footer { align-items: flex-start; flex-direction: column; }
  .account-order-item { grid-template-columns: 48px 1fr; }
  .account-order-item img, .account-order-image-placeholder { width: 48px; height: 58px; }
  .account-order-item b { grid-column: 2; }
  .announcement-bar { font-size: 0.62rem; }
  .announcement-bar span { display: block; margin: 0.2rem 0 0; }
  .new-hero { padding-top: 3rem; }
  .new-hero h1 { max-width: 12ch; font-size: 2.5rem; line-height: 1.08; }
  .new-actions { flex-direction: column; align-items: stretch; }
  .new-button { width: 100%; }
  .trust-strip, .testimonial-grid { grid-template-columns: 1fr 1fr; }
  .trust-strip { gap: 0.7rem; padding: 1rem 0.75rem; }
  .trust-item { display: block; min-height: 0; padding: 0.9rem; }
  .trust-icon { width: 48px; height: 48px; margin-bottom: 0.65rem; font-size: 1.35rem; }
  .trust-item strong { font-size: 0.78rem; }
  .trust-item small { font-size: 0.67rem; }
  .section-heading { align-items: flex-start; flex-direction: column; gap: 1rem; }
  .new-product-grid { gap: 0.7rem; }
  .new-product-info h3 { font-size: 1.05rem; }
  .bundle-images img { height: 240px; }
  .bundle-images img + img { height: 170px; }
  .moment-grid { grid-template-columns: 1fr; }
  .moment-large, .moment-large img { min-height: 320px; }
  .service-row { grid-template-columns: 1fr; }

  .shop-page { width: min(100% - 1.25rem, 1240px); padding: 1.5rem 0 3rem; }
  .shop-header { align-items: stretch; flex-direction: column; }
  .shop-header > div:last-child { display: grid !important; grid-template-columns: 1fr; width: 100%; }
  .shop-header select { width: 100%; min-height: 2.8rem; }
  .category-chips { margin: 0 -0.625rem; padding: 0 0.625rem 1rem; }
  .product-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.65rem; }
  .product-image-wrap { height: auto; aspect-ratio: 0.78; }
  .product-body { padding: 0.75rem; }
  .product-card h3 { font-size: 0.95rem; line-height: 1.3; }
  .product-description { min-height: 0; }

  .floating-whatsapp-btn {
    right: 1rem;
    bottom: max(1rem, env(safe-area-inset-bottom));
    width: 3.5rem;
    height: 3.5rem;
    padding: 0;
  }

  .floating-whatsapp-btn > span:last-child { display: none; }
  .floating-whatsapp-icon { width: 2.5rem; height: 2.5rem; background: transparent; }
  .floating-whatsapp-icon svg { width: 2rem; height: 2rem; }
}

@media (max-width: 640px) {
  .hero-banner {
    padding: 1.5rem;
    min-height: 360px;
  }

  .hero-content {
    padding: 1.2rem;
    max-width: 100%;
  }

  .hero-content h1 {
    font-size: clamp(2rem, 8vw, 3.2rem);
  }

  .feature-list {
    grid-template-columns: 1fr;
  }

  .cta-row {
    flex-direction: column;
  }

  .primary-btn,
  .secondary-btn {
    width: 100%;
  }

  .auth-card {
    padding: 1.6rem 1.1rem;
  }

  .auth-card h1 {
    font-size: 3rem;
  }

  .cart-item-card {
    grid-template-columns: 1fr;
  }

  .cart-item-card img {
    width: 100%;
    height: 240px;
  }

  .date-fields,
  .summary-actions {
    grid-template-columns: 1fr;
  }

  .navbar {
    padding: 0.8rem 0 0.7rem;
  }

  .navbar-container {
    padding: 0 0.8rem;
  }

  .auth-wrapper { margin: 0.75rem auto; padding: 0.75rem 0.65rem 2.5rem; }
  .auth-card { border-radius: 18px; padding: 1.5rem 1rem 1.35rem; }
  .auth-card h1 { font-size: 2.7rem; }
  .auth-card > p { font-size: 0.95rem; line-height: 1.45; }
  .auth-toggle { gap: 0.35rem; margin-bottom: 1rem; }
  .auth-toggle button { padding: 0.75rem 0.5rem; font-size: 0.95rem; }
  .auth-form label { font-size: 0.92rem; margin-top: 0.8rem; }
  .auth-form input, .auth-form select { min-height: 3rem; padding: 0.8rem; font-size: 0.95rem; }
  .phone-input-group { grid-template-columns: minmax(7rem, 0.8fr) minmax(0, 1fr); }
  .back-home-link { margin-top: 1.2rem; font-size: 0.9rem; }

  .brand-name {
    font-size: 1.8rem;
  }

  .nav-menu {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;
  }

  .nav-item {
    width: 100%;
    font-size: 1.1rem;
    padding: 0.15rem 0;
  }

  .nav-home > a {
    display: block;
    width: 100%;
    max-width: 180px;
  }

  .nav-dropdown,
  .nav-menu .nav-item .nav-dropdown {
    position: static;
    opacity: 0;
    visibility: hidden;
    transform: none;
    box-shadow: none;
    border: none;
    background: transparent;
    margin-top: 0.3rem;
    padding: 0 0 0.2rem 0;
    left: auto;
    display: none;
  }

  .nav-item.expanded .nav-dropdown {
    opacity: 1;
    visibility: visible;
    display: block;
  }

  .mega-dropdown {
    min-width: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    padding: 0;
  }

  .dropdown-column {
    min-width: 0;
  }

  .dropdown-column h4,
  .dropdown-card h4 {
    margin-bottom: 0.25rem;
  }

  .nav-phone {
    display: none;
  }

  .nav-actions {
    position: static;
    align-self: flex-end;
    margin-top: 0.35rem;
  }

  .checkout-page {
    width: min(100% - 1.25rem, 760px);
    padding-top: 1.5rem;
  }

  .checkout-form {
    padding: 1.15rem;
  }

  .checkout-grid {
    grid-template-columns: 1fr;
  }

  .checkout-grid > label:last-child:nth-child(3) {
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iFAAiF;EACjF,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,iDAAiD;EACjD,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,0BAA0B,aAAa,EAAE;;AAEzC;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;;EAEE,cAAc;EACd,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB,qCAAqC,EAAE;AAC9D,yBAAyB,cAAc,EAAE,oBAAoB,EAAE,sBAAsB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC7I,sBAAsB,wBAAwB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,WAAW,EAAE,6BAA6B,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,6BAA6B,EAAE,2BAA2B,EAAE;AACrP,4BAA4B,WAAW,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAClF,qBAAqB,aAAa,EAAE,+CAA+C,EAAE,WAAW,EAAE;AAClG,4BAA4B,YAAY,EAAE;;AAE1C;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;;;EASE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,qCAAqC;EACrC,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,aAAa,+BAA+B,EAAE,cAAc,EAAE,sBAAsB,EAAE;AACtF,eAAe,aAAa,EAAE,gBAAgB,EAAE,8BAA8B,EAAE,SAAS,EAAE,qBAAqB,EAAE;AAClH,kBAAkB,iBAAiB,EAAE,cAAc,EAAE;AACrD,sBAAsB,uBAAuB,EAAE;AAC/C,kBAAkB,aAAa,EAAE,WAAW,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACxF,yBAAyB,yBAAyB,EAAE,oBAAoB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACzJ,8DAA8D,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE1H;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb;+HAC6H;EAC7H,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,iDAAiD;EACjD,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA,qBAAqB,YAAY,EAAE;AACnC,sDAAsD,YAAY,EAAE;;AAEpE;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,gCAAgC,cAAc,EAAE,UAAU,EAAE;;AAE5D;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;oCACoC,0BAA0B,EAAE,aAAa,EAAE;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,oBAAoB;IACpB,8CAA8C;EAChD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA,mFAAmF;AACnF;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,4CAA4C;EAC5C,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,wEAAwE;AAC1E;;AAEA;EACE,QAAQ;EACR,yEAAyE;AAC3E;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;AAEA,aAAa,WAAW,EAAE;AAC1B,YAAY,aAAa,EAAE,4DAA4D,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,iDAAiD,EAAE,+DAA+D,EAAE,iDAAiD,EAAE;AAClT,iBAAiB,gBAAgB,EAAE,iBAAiB,EAAE;AACtD,cAAc,qBAAqB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE;AAClJ,eAAe,gBAAgB,EAAE,uBAAuB,EAAE,sCAAsC,EAAE,sCAAsC,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AAClM,cAAc,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3F,eAAe,aAAa,EAAE,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAC9E,cAAc,6BAA6B,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,WAAW,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,uDAAuD,EAAE;AAC3P,oBAAoB,4BAA4B,EAAE,2BAA2B,EAAE;AAC/E,mBAAmB,oBAAoB,EAAE;AACzC,oBAAoB,uBAAuB,EAAE,kBAAkB,EAAE;AACjE,cAAc,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC1I,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC3I,wBAAwB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACtE,oBAAoB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,aAAa,EAAE,+BAA+B,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,0CAA0C,EAAE,sBAAsB,EAAE,qCAAqC,EAAE,kDAAkD,EAAE;AACtU,yBAAyB,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE;AAC3J,2BAA2B,sCAAsC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACzG,sBAAsB,kBAAkB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACjF,eAAe,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,oCAAoC,EAAE,mBAAmB,EAAE,+CAA+C,EAAE,kDAAkD,EAAE;AAC3P,cAAc,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,0CAA0C,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,4CAA4C,EAAE;AACjP,cAAc,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE,4CAA4C,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnO,8BAA8B,mBAAmB,EAAE;AACnD,iCAAiC,mBAAmB,EAAE,cAAc,EAAE;AACtE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,0CAA0C,cAAc,EAAE,4CAA4C,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACjK,wCAAwC,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,4CAA4C,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACpM,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,qDAAqD,EAAE;AAC1G,mBAAmB,aAAa,EAAE,gBAAgB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACpH,sBAAsB,mBAAmB,EAAE,sCAAsC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC/J,qBAAqB,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACnF,eAAe,SAAS,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAClI,iBAAiB,aAAa,EAAE,oDAAoD,EAAE,SAAS,EAAE;AACjG,iBAAiB,SAAS,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1F,qBAAqB,WAAW,EAAE,kBAAkB,EAAE,kCAAkC,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACpI,wBAAwB,cAAc,EAAE,sCAAsC,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACtH,uBAAuB,cAAc,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpG,mBAAmB,eAAe,EAAE,wBAAwB,EAAE,+CAA+C,EAAE,kDAAkD,EAAE;AACnK,uBAAuB,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACjF,oBAAoB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AACrF,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,2CAA2C,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,kDAAkD,EAAE,uDAAuD,EAAE;AACxP,0BAA0B,2BAA2B,EAAE,mDAAmD,EAAE;AAC5G,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACpG,yBAAyB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,gCAAgC,EAAE;AACzG,iDAAiD,sBAAsB,EAAE;AACzE,4BAA4B,kBAAkB,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE;AAC/M,4BAA4B,kBAAkB,EAAE,YAAY,EAAE,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACjL,oBAAoB,uBAAuB,EAAE;AAC7C,0BAA0B,mBAAmB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AAC9F,uBAAuB,iBAAiB,EAAE,sCAAsC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACvH,2BAA2B,kBAAkB,EAAE,kBAAkB,EAAE;AACnE,kBAAkB,aAAa,EAAE,kCAAkC,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AAC5I,iBAAiB,aAAa,EAAE,kCAAkC,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACnG,qBAAqB,WAAW,EAAE,aAAa,EAAE,iBAAiB,EAAE;AACpE,2BAA2B,aAAa,EAAE;AAC1C,eAAe,gBAAgB,EAAE;AACjC,kBAAkB,qBAAqB,EAAE,sCAAsC,EAAE,uCAAuC,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC/J,iBAAiB,mBAAmB,EAAE,gBAAgB,EAAE;AACxD,2BAA2B,cAAc,EAAE,kBAAkB,EAAE;AAC/D,qBAAqB,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC/F,mBAAmB,mBAAmB,EAAE;AACxC,YAAY,uBAAuB,EAAE,kBAAkB,EAAE;AACzD,eAAe,aAAa,EAAE,kCAAkC,EAAE,SAAS,EAAE,iBAAiB,EAAE,YAAY,EAAE;AAC9G,gBAAgB,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC9F,oBAAoB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AACrF,sBAAsB,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,aAAa,EAAE,iCAAiC,EAAE;AACnI,2CAA2C,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;AACvJ,oCAAoC,mBAAmB,EAAE,sCAAsC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACzJ,eAAe,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACnH,4BAA4B,sBAAsB,EAAE,gBAAgB,EAAE;AACtE,oBAAoB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE;AACrF,+BAA+B,eAAe,EAAE,mBAAmB,EAAE;AACrE,sCAAsC,kBAAkB,EAAE,sBAAsB,EAAE;AAClF,sBAAsB,gBAAgB,EAAE,mBAAmB,EAAE,sCAAsC,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC5I,2BAA2B,kBAAkB,EAAE,gBAAgB,EAAE;AACjE,iCAAiC,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC7G,iBAAiB,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACnH,cAAc,aAAa,EAAE,mBAAmB,EAAE,aAAa,EAAE,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACnK,oBAAoB,iBAAiB,EAAE,wCAAwC,EAAE,mCAAmC,EAAE,gBAAgB,EAAE;AACxI,mBAAmB,qBAAqB,EAAE,mBAAmB,EAAE;AAC/D,eAAe,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,+BAA+B,EAAE,mBAAmB,EAAE;AACtI,qBAAqB,aAAa,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAEtE,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,oCAAoC,EAAE;AACzF,gBAAgB,gBAAgB,EAAE,oBAAoB,EAAE;AACxD,mBAAmB,qBAAqB,EAAE,sCAAsC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC3J,+BAA+B,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC5G,wBAAwB,aAAa,EAAE,gDAAgD,EAAE,kBAAkB,EAAE,SAAS,EAAE;AACxH,uBAAuB,aAAa,EAAE,0CAA0C,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,8CAA8C,EAAE;AAC5K,uBAAuB,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE;AACpI,0BAA0B,uBAAuB,EAAE,sCAAsC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AACpJ,+BAA+B,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC1F,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,6BAA6B,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACzQ,wBAAwB,uBAAuB,EAAE,WAAW,EAAE;;AAE9D,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,oCAAoC,EAAE;AACzF,kBAAkB,oBAAoB,EAAE,iDAAiD,EAAE;AAC3F,qBAAqB,iBAAiB,EAAE,sCAAsC,EAAE,qCAAqC,EAAE,gBAAgB,EAAE;AACzI,iCAAiC,mBAAmB,EAAE;AACtD,mBAAmB,gBAAgB,EAAE;AACrC,sBAAsB,qBAAqB,EAAE,sCAAsC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxH,uBAAuB,mBAAmB,EAAE,gBAAgB,EAAE;AAC9D,wBAAwB,aAAa,EAAE,qCAAqC,EAAE,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,2CAA2C,EAAE,qBAAqB,EAAE,qCAAqC,EAAE,8CAA8C,EAAE;AACxR,8BAA8B,aAAa,EAAE,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACrH,4DAA4D,WAAW,EAAE,mBAAmB,EAAE;AAC9F,2BAA2B,aAAa,EAAE,eAAe,EAAE,YAAY,EAAE,mBAAmB,EAAE;AAC9F,2BAA2B,aAAa,EAAE,qCAAqC,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,2CAA2C,EAAE,qBAAqB,EAAE,qCAAqC,EAAE,8CAA8C,EAAE;AAClT,iEAAiE,cAAc,EAAE;AACjF,gCAAgC,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE;AAC7I,kCAAkC,cAAc,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC3F,kCAAkC,mBAAmB,EAAE;AACvD,0BAA0B,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAClF,sBAAsB,aAAa,EAAE,SAAS,EAAE;AAChD,iBAAiB,gBAAgB,EAAE,0CAA0C,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAC3H,+CAA+C,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE;AAC9H,wBAAwB,oBAAoB,EAAE,kDAAkD,EAAE;AAClG,4DAA4D,cAAc,EAAE;AAC5E,uBAAuB,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE;AACpJ,8BAA8B,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC5F,gBAAgB,wBAAwB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACtK,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,kDAAkD,mBAAmB,EAAE,cAAc,EAAE;AACvF,uBAAuB,aAAa,EAAE,YAAY,EAAE,eAAe,EAAE;AACrE,sBAAsB,aAAa,EAAE,oCAAoC,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAC7G,4DAA4D,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACvJ,mCAAmC,aAAa,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE;AAC9I,iEAAiE,cAAc,EAAE;AACjF,kCAAkC,sCAAsC,EAAE,kBAAkB,EAAE;AAC9F,8EAA8E,mBAAmB,EAAE,kBAAkB,EAAE;AACvH,sDAAsD,iBAAiB,EAAE;AACzE,wBAAwB,mBAAmB,EAAE,+CAA+C,EAAE;AAC9F,cAAc,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC/G,oBAAoB,cAAc,EAAE,gBAAgB,EAAE,oDAAoD,EAAE;AAC5G,4BAA4B,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,oDAAoD,EAAE;AACzJ;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,6BAA6B,0BAA0B,EAAE;EACzD,iBAAiB,SAAS,EAAE;EAC5B,kBAAkB,WAAW,EAAE;EAC/B,iBAAiB,aAAa,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,6BAA6B,EAAE;EACzG,iBAAiB,eAAe,EAAE,wBAAwB,EAAE;EAC5D,oBAAoB,qCAAqC,EAAE;EAC3D,eAAe,eAAe,EAAE;EAChC,eAAe,qCAAqC,EAAE;EACtD,eAAe,SAAS,EAAE,oBAAoB,EAAE;EAChD,cAAc,YAAY,EAAE,iBAAiB,EAAE,aAAa,EAAE;EAC9D,cAAc,gBAAgB,EAAE,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;EACvG,qBAAqB,kBAAkB,EAAE;EACzC,oBAAoB,kBAAkB,EAAE;AAC1C;;AAEA;EACE,gBAAgB,iBAAiB,EAAE;EACnC,wBAAwB,0BAA0B,EAAE;EACpD,uBAAuB,aAAa,EAAE,eAAe,EAAE;EACvD,0BAA0B,iBAAiB,EAAE;EAC7C,gBAAgB,mBAAmB,EAAE;EACrC,wBAAwB,0BAA0B,EAAE,aAAa,EAAE;EACnE,2BAA2B,0BAA0B,EAAE,kBAAkB,EAAE,aAAa,EAAE;EAC1F,iBAAiB,aAAa,EAAE;EAChC,+CAA+C,uBAAuB,EAAE,sBAAsB,EAAE;EAChG,sBAAsB,+BAA+B,EAAE;EACvD,4DAA4D,WAAW,EAAE,YAAY,EAAE;EACvF,wBAAwB,cAAc,EAAE;EACxC,oBAAoB,kBAAkB,EAAE;EACxC,yBAAyB,cAAc,EAAE,kBAAkB,EAAE;EAC7D,YAAY,iBAAiB,EAAE;EAC/B,eAAe,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;EACtE,eAAe,sBAAsB,EAAE,oBAAoB,EAAE;EAC7D,cAAc,WAAW,EAAE;EAC3B,kCAAkC,8BAA8B,EAAE;EAClE,eAAe,WAAW,EAAE,qBAAqB,EAAE;EACnD,cAAc,cAAc,EAAE,aAAa,EAAE,eAAe,EAAE;EAC9D,cAAc,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;EACrF,qBAAqB,kBAAkB,EAAE;EACzC,oBAAoB,kBAAkB,EAAE;EACxC,mBAAmB,uBAAuB,EAAE,sBAAsB,EAAE,SAAS,EAAE;EAC/E,oBAAoB,WAAW,EAAE;EACjC,uBAAuB,kBAAkB,EAAE;EAC3C,qBAAqB,aAAa,EAAE;EACpC,2BAA2B,aAAa,EAAE;EAC1C,eAAe,0BAA0B,EAAE;EAC3C,mCAAmC,iBAAiB,EAAE;EACtD,eAAe,0BAA0B,EAAE;;EAE3C,aAAa,kCAAkC,EAAE,sBAAsB,EAAE;EACzE,eAAe,oBAAoB,EAAE,sBAAsB,EAAE;EAC7D,gCAAgC,wBAAwB,EAAE,0BAA0B,EAAE,WAAW,EAAE;EACnG,sBAAsB,WAAW,EAAE,kBAAkB,EAAE;EACvD,kBAAkB,mBAAmB,EAAE,wBAAwB,EAAE;EACjE,gBAAgB,gDAAgD,EAAE,YAAY,EAAE;EAChF,sBAAsB,YAAY,EAAE,kBAAkB,EAAE;EACxD,gBAAgB,gBAAgB,EAAE;EAClC,mBAAmB,kBAAkB,EAAE,gBAAgB,EAAE;EACzD,uBAAuB,aAAa,EAAE;;EAEtC;IACE,WAAW;IACX,8CAA8C;IAC9C,aAAa;IACb,cAAc;IACd,UAAU;EACZ;;EAEA,2CAA2C,aAAa,EAAE;EAC1D,0BAA0B,aAAa,EAAE,cAAc,EAAE,uBAAuB,EAAE;EAClF,8BAA8B,WAAW,EAAE,YAAY,EAAE;AAC3D;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA,gBAAgB,oBAAoB,EAAE,+BAA+B,EAAE;EACvE,aAAa,mBAAmB,EAAE,4BAA4B,EAAE;EAChE,gBAAgB,iBAAiB,EAAE;EACnC,iBAAiB,kBAAkB,EAAE,iBAAiB,EAAE;EACxD,eAAe,YAAY,EAAE,mBAAmB,EAAE;EAClD,sBAAsB,uBAAuB,EAAE,kBAAkB,EAAE;EACnE,mBAAmB,kBAAkB,EAAE,kBAAkB,EAAE;EAC3D,sCAAsC,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE;EAC7F,qBAAqB,yDAAyD,EAAE;EAChF,kBAAkB,kBAAkB,EAAE,iBAAiB,EAAE;;EAEzD;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Allura&family=Cormorant+Garamond:wght@400;500;600;700&family=Manrope:wght@400;500;600;700;800&family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f1ee;\n  color: #2f2a28;\n}\n\nimg {\n  max-width: 100%;\n  display: block;\n}\n\nbutton {\n  font: inherit;\n  cursor: pointer;\n}\n\n.navbar {\n  background: linear-gradient(180deg, #f7e6eb 0%, #f4dfe7 100%);\n  border-bottom: 1px solid rgba(131, 93, 104, 0.12);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  padding: 0.75rem 0 0.5rem;\n}\n\n.navbar-keyboard-hidden { display: none; }\n\n.navbar-container {\n  max-width: 1460px;\n  margin: 0 auto;\n  padding: 0 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.2rem;\n}\n\n.brand-block {\n  min-width: 220px;\n  display: flex;\n  align-items: center;\n}\n\n.brand-name {\n  color: #1a1a1a;\n  text-decoration: none;\n  font-family: 'Allura', cursive;\n  font-size: 2.2rem;\n  font-weight: 400;\n  letter-spacing: 0.03em;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.nav-menu {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.6rem;\n  flex: 1;\n  flex-wrap: wrap;\n}\n\n.nav-item {\n  position: relative;\n  color: #2f2323;\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 1.05rem;\n  font-weight: 600;\n  padding: 0.7rem 0.2rem;\n  cursor: pointer;\n  letter-spacing: 0.02em;\n}\n\n.nav-item > a,\n.nav-item > span {\n  text-decoration: none;\n  color: inherit;\n}\n\n.nav-disclosure {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n}\n\n.mobile-nav-toggle {\n  display: none;\n}\n\n.nav-item:hover > a,\n.nav-item:hover > span {\n  color: #a6546a;\n}\n\n.nav-item:hover .nav-dropdown,\n.nav-item.expanded .nav-dropdown {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.nav-dropdown {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 0;\n  min-width: 220px;\n  background: #fff;\n  border: 1px solid #f0e7e2;\n  border-radius: 14px;\n  box-shadow: 0 18px 35px rgba(67, 41, 41, 0.12);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(8px);\n  transition: all 0.2s ease;\n  z-index: 20;\n}\n\n.mega-dropdown {\n  display: flex;\n  gap: 1.5rem;\n  min-width: 460px;\n  padding: 1.25rem;\n}\n\n.dropdown-column {\n  min-width: 150px;\n}\n\n.dropdown-column h4,\n.dropdown-card h4 {\n  margin-bottom: 0.7rem;\n  color: #2f2224;\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.dropdown-column ul,\n.dropdown-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.dropdown-column li,\n.dropdown-card li {\n  color: #554947;\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n.dropdown-column li a,\n.dropdown-card li a {\n  display: block;\n  padding: 0.28rem 0.45rem;\n  border-radius: 5px;\n  color: #554947;\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 1.02rem;\n  font-weight: 500;\n  line-height: 1.25;\n  text-decoration: none;\n  transition: color 160ms ease, background-color 160ms ease;\n}\n\n.dropdown-column li a:hover,\n.dropdown-column li a:focus-visible,\n.dropdown-card li a:hover,\n.dropdown-card li a:focus-visible {\n  background: #f8e7ec;\n  color: #a6546a;\n  outline: none;\n}\n\n.home-dropdown {\n  min-width: 230px;\n  padding: 1rem;\n}\n\n.dropdown-card p {\n  color: #5d4f4d;\n  line-height: 1.6;\n  margin-bottom: 0.8rem;\n}\n\n.contact-dropdown {\n  min-width: 240px;\n  padding: 1rem;\n}\n\n.contact-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.contact-label {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #a6546a;\n  font-weight: 700;\n  margin: 0.3rem 0;\n}\n\n.nav-phone {\n  color: #262626;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  font-family: 'Manrope', sans-serif;\n}\n\n.nav-actions {\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.icon-link {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  color: #3f2b21;\n  border-radius: 50%;\n  transition: background-color 160ms ease, color 160ms ease;\n}\n\n.icon-link:hover,\n.icon-link:focus-visible {\n  color: #a6546a;\n  background: rgba(255, 255, 255, 0.65);\n  outline: none;\n}\n\n.icon-link svg {\n  width: 1.55rem;\n  height: 1.55rem;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.logout-button {\n  border: 1px solid rgba(166, 84, 106, 0.45);\n  border-radius: 0.35rem;\n  background: transparent;\n  color: #8f4057;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.logout-button:hover { background: rgba(255, 255, 255, 0.65); }\n.whatsapp-purpose-note { display: block; margin-top: -0.35rem; margin-bottom: 0.75rem; color: #8f4057; font-size: 0.72rem; line-height: 1.4; }\n.same-number-option { display: flex !important; flex-direction: row; align-items: center; gap: 0.5rem; margin-top: 0.6rem !important; margin-bottom: -0.2rem; color: #5f4c49 !important; font-size: 0.78rem !important; font-weight: 600 !important; }\n.same-number-option input { width: 1rem; min-height: 1rem; accent-color: #a6546a; }\n.phone-input-group { display: grid; grid-template-columns: minmax(9rem, 0.45fr) 1fr; gap: 0.5rem; }\n.phone-input-group select { min-width: 0; }\n\n.cart-count {\n  position: absolute;\n  top: -0.15rem;\n  right: -0.2rem;\n  min-width: 1.2rem;\n  height: 1.2rem;\n  padding: 0 0.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: #c54078;\n  color: #fff;\n  font: 700 0.68rem/1 'Manrope', sans-serif;\n  border: 2px solid #f5e2e7;\n}\n\n.nav-menu .nav-item .nav-dropdown {\n  left: 50%;\n  transform: translate(-50%, 8px);\n}\n\n.nav-menu .nav-item:hover .nav-dropdown {\n  left: 50%;\n}\n\n.footer {\n  background-color: #2c1d27;\n  color: #fff;\n  padding: 2rem;\n  text-align: center;\n  margin-top: auto;\n}\n\n.home,\n.shop,\n.product-detail,\n.cart,\n.checkout,\n.contact,\n.order-tracking,\n.login,\n.register {\n  max-width: 1200px;\n  margin: 2rem auto;\n  padding: 2rem;\n}\n\n.checkout-page {\n  width: min(100% - 2rem, 1040px);\n  margin: 0 auto;\n  padding: 2.6rem 0 4rem;\n}\n\n.checkout-header {\n  margin-bottom: 1.3rem;\n}\n\n.checkout-header h1 {\n  color: #3f2b21;\n  font-family: 'Cormorant Garamond', serif;\n  font-size: clamp(2.3rem, 5vw, 3.5rem);\n  line-height: 1;\n  margin-bottom: 0.35rem;\n}\n\n.checkout-header p:last-child,\n.checkout-note {\n  color: #8b7b73;\n  font-size: 0.82rem;\n}\n\n.checkout-form {\n  width: min(100%, 760px);\n  padding: 1.55rem 1.6rem;\n  border: 1px solid #eee1df;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.76);\n  box-shadow: 0 12px 36px rgba(70, 43, 35, 0.04);\n}\n\n.checkout-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.checkout-section h2,\n.checkout-section h3 {\n  color: #4a352b;\n  font-family: 'Cormorant Garamond', serif;\n  margin-bottom: 0.25rem;\n}\n\n.checkout-section h2 {\n  font-size: 1.45rem;\n}\n\n.checkout-section h3 {\n  font-family: 'Manrope', sans-serif;\n  font-size: 0.88rem;\n}\n\n.checkout-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  color: #695850;\n  font-size: 0.75rem;\n}\n\n.checkout-form input,\n.checkout-form select {\n  width: 100%;\n  min-height: 2.55rem;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid #eadbd9;\n  border-radius: 10px;\n  background: #fff;\n  color: #4b3931;\n  outline: none;\n}\n\n.checkout-form input:focus,\n.checkout-form select:focus {\n  border-color: #b9798c;\n  box-shadow: 0 0 0 3px rgba(185, 121, 140, 0.12);\n}\n\n.checkout-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.8rem;\n  margin: 0.8rem 0;\n}\n\n.checkout-grid > label:last-child:nth-child(3) {\n  grid-column: 1 / -1;\n}\n\n.delivery-section,\n.checkout-rule {\n  border-top: 1px solid #eee1df;\n  margin-top: 0.8rem;\n  padding-top: 1rem;\n}\n\n.checkout-note {\n  line-height: 1.45;\n}\n\n.checkout-total {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.42rem 0;\n  color: #6c5b53;\n  font-size: 0.85rem;\n}\n\n.checkout-total strong {\n  color: #4b3931;\n}\n\n.checkout-total.total-emphasis {\n  border-top: 1px solid #eee1df;\n  margin-top: 0.25rem;\n  padding-top: 0.75rem;\n  font-weight: 700;\n  color: #4b3931;\n}\n\n.checkout-form > .primary-btn {\n  width: 100%;\n  margin-top: 0.75rem;\n}\n\n.shop-page { width: min(100% - 2rem, 1240px); margin: 0 auto; padding: 2.5rem 0 4rem; }\n.shop-header { display: flex; align-items: end; justify-content: space-between; gap: 1rem; margin-bottom: 1.2rem; }\n.shop-header h1 { margin-top: .3rem; color: #432d21; }\n.shop-header select { width: min(100%, 240px); }\n.category-chips { display: flex; gap: .55rem; overflow-x: auto; padding-bottom: 1.3rem; }\n.category-chips button { border: 1px solid #eadbd9; border-radius: 999px; padding: .55rem .85rem; background: #fff; color: #654f46; white-space: nowrap; }\n.category-chips button.active, .category-chips button:hover { border-color: #a6546a; background: #f8e7ec; color: #8d4058; }\n\n.page-loading,\n.empty-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n  font-size: 1.1rem;\n  color: #666;\n}\n\n.home-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 1.5rem 1rem 4rem;\n}\n\n.hero-banner {\n  min-height: 420px;\n  border-radius: 18px;\n  padding: 3rem;\n  background: linear-gradient(135deg, rgba(255,255,255,0.5), rgba(245,236,232,0.9)),\n    url('https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=1400&q=80') center/cover no-repeat;\n  display: flex;\n  align-items: center;\n}\n\n.hero-content {\n  max-width: 540px;\n  background: rgba(255, 255, 255, 0.52);\n  border: 1px solid rgba(171, 126, 107, 0.18);\n  backdrop-filter: blur(2px);\n  border-radius: 20px;\n  padding: 2rem;\n}\n\n.eyebrow,\n.section-kicker {\n  display: inline-block;\n  font-size: 0.72rem;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #bf5570;\n  font-weight: 700;\n}\n\n.hero-content h1 {\n  font-size: clamp(2.2rem, 4vw, 4rem);\n  line-height: 1.1;\n  margin: 1rem 0;\n  color: #2f2a28;\n}\n\n.hero-content p {\n  font-size: 1.05rem;\n  color: #4d3d39;\n  line-height: 1.7;\n}\n\n.hero-actions {\n  margin-top: 1.5rem;\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.hero-actions button,\n.primary-btn,\n.secondary-btn,\n.whatsapp-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 0.9rem 1.4rem;\n  font-weight: 600;\n  transition: 0.2s ease;\n}\n\n.hero-actions button,\n.primary-btn {\n  background: #a6546a;\n  color: white;\n}\n\n.hero-actions .secondary,\n.secondary-btn {\n  background: transparent;\n  border: 1px solid #a6546a;\n  color: #a6546a;\n}\n\n.products-section {\n  margin-top: 3rem;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.section-header h2 {\n  font-size: clamp(2rem, 3vw, 3rem);\n  margin-top: 0.5rem;\n}\n\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.product-card {\n  background: #fff;\n  border: 1px solid #f0e7e2;\n  border-radius: 18px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 35px rgba(36, 22, 22, 0.08);\n}\n\n.product-image-wrap {\n  height: 280px;\n  overflow: hidden;\n  background: #f6f0ee;\n}\n\n.product-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.45s ease;\n}\n\n.product-card:hover .product-image {\n  transform: scale(1.06);\n}\n\n.product-body {\n  padding: 1rem;\n}\n\n.product-meta {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.7rem;\n  flex-wrap: wrap;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  background: #f3e5e8;\n  color: #8d4d5f;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  padding: 0.3rem 0.6rem;\n  font-weight: 700;\n}\n\n.badge.accent {\n  background: #f4d9de;\n}\n\n.product-card h3 {\n  font-size: 1.15rem;\n  margin-bottom: 0.5rem;\n}\n\n.product-description {\n  color: #5e4f4a;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  min-height: 64px;\n}\n\n.product-pricing {\n  margin-top: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.price,\n.detail-price {\n  color: #2d1f24;\n  font-weight: 800;\n  font-size: 1.2rem;\n}\n\n.original-price,\n.detail-original {\n  color: #8b8b8b;\n  text-decoration: line-through;\n  font-size: 0.92rem;\n}\n\n.product-detail-page {\n  max-width: 1200px;\n  margin: 2rem auto;\n  padding: 2rem 1rem 4rem;\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  gap: 2.5rem;\n}\n\n.product-gallery {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.main-image-wrap {\n  background: #fff;\n  border: 1px solid #f1e7e3;\n  border-radius: 22px;\n  padding: 1rem;\n}\n\n.main-product-image {\n  width: 100%;\n  height: 620px;\n  object-fit: cover;\n  border-radius: 16px;\n}\n\n.product-video-wrap {\n  background: #fff;\n  border: 1px solid #f1e7e3;\n  border-radius: 22px;\n  padding: 1rem;\n}\n\n.product-detail-video {\n  display: block;\n  width: 100%;\n  height: 620px;\n  object-fit: cover;\n  border-radius: 16px;\n  background: #f6f0ee;\n}\n\n.thumb-row {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.thumb {\n  width: 110px;\n  height: 110px;\n  border: 2px solid transparent;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  padding: 0;\n}\n\n.thumb.active {\n  border-color: #bf5570;\n}\n\n.thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.product-info {\n  padding-top: 0.5rem;\n}\n\n.product-info h1 {\n  font-size: clamp(2.1rem, 3vw, 3rem);\n  line-height: 1.15;\n  margin-bottom: 1rem;\n}\n\n.detail-text {\n  font-size: 1.02rem;\n  line-height: 1.8;\n  color: #564c4a;\n  margin-bottom: 1.25rem;\n}\n\n.price-block {\n  display: flex;\n  align-items: baseline;\n  gap: 0.9rem;\n  margin-bottom: 1.5rem;\n}\n\n.selector-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  color: #473d3b;\n  font-weight: 600;\n  margin-bottom: 0.7rem;\n}\n\n.text-link {\n  border: none;\n  background: transparent;\n  color: #c3647a;\n  font-size: 0.83rem;\n}\n\n.size-options {\n  display: flex;\n  gap: 0.7rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.25rem;\n}\n\n.size-btn {\n  border: 1px solid #d8c7bf;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.7rem 1rem;\n  min-width: 110px;\n  color: #413a38;\n}\n\n.size-btn.selected {\n  background: #f5dfe6;\n  border-color: #bf5570;\n  color: #7b2f46;\n  font-weight: 700;\n}\n\n.order-note {\n  border: 1px solid #f0d7da;\n  padding: 0.9rem 1rem;\n  border-radius: 12px;\n  background: #fff9fa;\n  color: #594a4a;\n  margin-bottom: 1.25rem;\n}\n\n.quantity-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 260px;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n  color: #3a2d2b;\n}\n\n.quantity-box {\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid #d8c7bf;\n  border-radius: 10px;\n  overflow: hidden;\n  background: white;\n}\n\n.quantity-box button {\n  width: 38px;\n  height: 38px;\n  border: none;\n  background: transparent;\n  font-size: 1.3rem;\n}\n\n.quantity-box span {\n  min-width: 42px;\n  text-align: center;\n}\n\n.cta-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.primary-btn,\n.secondary-btn {\n  min-width: 180px;\n}\n\n.whatsapp-btn {\n  width: 100%;\n  background: #effaf3;\n  border: 1px solid #bfe0c5;\n  color: #2d7c46;\n  margin-bottom: 1.5rem;\n}\n\n.feature-list {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.feature-list div {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  color: #524845;\n  font-size: 0.84rem;\n  border-top: 1px solid #efe5e1;\n  padding-top: 1rem;\n}\n\n.feature-list strong {\n  color: #338f5b;\n}\n\n.auth-wrapper {\n  max-width: 1200px;\n  margin: 2rem auto;\n  padding: 1.5rem 1rem 4rem;\n}\n\n.auth-card {\n  width: min(100%, 760px);\n  margin: 0 auto;\n  background: #f8f4f1;\n  border: 1px solid rgba(150, 106, 87, 0.25);\n  border-radius: 26px;\n  padding: 2.5rem clamp(1.1rem, 4vw, 2.2rem) 2.1rem;\n  box-shadow: 0 18px 30px rgba(101, 75, 58, 0.04);\n}\n\n.auth-card h1 {\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 4rem;\n  font-weight: 600;\n  color: #3b2a20;\n  line-height: 1;\n  margin-bottom: 0.75rem;\n}\n\n.auth-card > p {\n  font-size: 1.2rem;\n  color: #4f3f3d;\n  font-weight: 400;\n  margin-bottom: 1.75rem;\n}\n\n.auth-toggle {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.8rem;\n  background: #e9e3e1;\n  border-radius: 14px;\n  padding: 0.35rem;\n  margin-bottom: 1.8rem;\n}\n\n.auth-toggle button {\n  background: transparent;\n  border: none;\n  border-radius: 12px;\n  padding: 1rem;\n  font-size: 1.1rem;\n  color: #574540;\n  font-weight: 600;\n}\n\n.auth-toggle button.active {\n  background: #f5f2f1;\n  box-shadow: 0 1px 0 rgba(0,0,0,0.04);\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.auth-form label {\n  font-size: 1.05rem;\n  color: #3e2c28;\n  margin-top: 1.1rem;\n  margin-bottom: 0.35rem;\n}\n\n.auth-form input {\n  width: 100%;\n  border: 1px solid rgba(131, 93, 104, 0.3);\n  border-radius: 14px;\n  background: rgba(255,255,255,0.08);\n  padding: 1rem 1rem;\n  font-size: 1rem;\n  color: #3d2a2a;\n  outline: none;\n}\n\n.phone-input-group { min-width: 0; }\n.phone-input-group input, .phone-input-group select { min-width: 0; }\n\n.auth-form input:focus {\n  border-color: #b96e80;\n  box-shadow: 0 0 0 2px rgba(185, 110, 128, 0.08);\n}\n\n.auth-form input::placeholder { color: #b7adae; opacity: 1; }\n\n.auth-error {\n  margin-top: 0.8rem;\n  background: #fff3f4;\n  border: 1px solid #f1c6ce;\n  border-radius: 10px;\n  padding: 0.8rem 1rem;\n  color: #8d2f3f;\n}\n\n.auth-submit {\n  margin-top: 1.4rem;\n  background: linear-gradient(180deg, #4a2f29 0%, #362821 100%);\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  padding: 1rem 1.4rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.auth-bottom-signup {\n  display: block;\n  margin: 1rem auto 0;\n  border: 0;\n  background: transparent;\n  color: #a6546a;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.auth-bottom-signup:hover,\n.auth-bottom-signup:focus-visible { text-decoration: underline; outline: none; }\n\n.back-home-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 1.8rem auto 0;\n  color: #3b2a20;\n  text-decoration: none;\n  font-size: 1.05rem;\n  font-weight: 600;\n}\n\n.cart-page {\n  max-width: 1280px;\n  margin: 3rem auto;\n  padding: 0 1.2rem 4rem;\n}\n\n.cart-header-block {\n  margin-bottom: 2rem;\n}\n\n.cart-header-block h1 {\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 4rem;\n  line-height: 1;\n  color: #3c2d28;\n  margin-bottom: 0.5rem;\n}\n\n.cart-header-block p {\n  color: #6b5d5a;\n  font-size: 1.05rem;\n}\n\n.cart-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 2.2fr) minmax(300px, 1fr);\n  gap: 2.2rem;\n  align-items: start;\n}\n\n.cart-items-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n\n.cart-item-card {\n  display: grid;\n  grid-template-columns: 170px 1fr auto;\n  gap: 1.25rem;\n  padding: 1.4rem 1.2rem;\n  background: #f9f4f2;\n  border: 1px solid rgba(150, 106, 87, 0.24);\n  border-radius: 18px;\n}\n\n.cart-item-card img {\n  width: 170px;\n  height: 170px;\n  border-radius: 16px;\n  object-fit: cover;\n}\n\n.cart-item-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.cart-item-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.cart-item-row h3 {\n  font-size: 2rem;\n  font-family: 'Cormorant Garamond', serif;\n  color: #2f2323;\n  margin-bottom: 0.25rem;\n}\n\n.cart-item-row p {\n  color: #645756;\n  font-size: 0.95rem;\n}\n\n.remove-item {\n  border: none;\n  background: transparent;\n  color: #3a2c2a;\n  font-size: 2rem;\n  line-height: 1;\n}\n\n.cart-item-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.mini-box {\n  border-radius: 999px;\n  overflow: hidden;\n  border: 1px solid rgba(84, 66, 61, 0.32);\n}\n\n.mini-box button {\n  width: 34px;\n  height: 34px;\n  font-size: 1.4rem;\n}\n\n.cart-item-price {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #2a2322;\n}\n\n.date-block {\n  margin-top: 0.6rem;\n}\n\n.date-block h2 {\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 2.4rem;\n  color: #2f2323;\n  margin-bottom: 0.8rem;\n}\n\n.date-block p {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #5c4d48;\n  margin-bottom: 1.25rem;\n}\n\n.date-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.2rem;\n}\n\n.date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.date-field label {\n  color: #473d3d;\n  font-weight: 600;\n}\n\n.date-field input {\n  border: 1px solid rgba(131, 93, 104, 0.25);\n  padding: 0.9rem 1rem;\n  border-radius: 12px;\n  background: rgba(255,255,255,0.08);\n  font-size: 1rem;\n}\n\n.cart-summary-panel {\n  background: #f9f3f1;\n  border: 1px solid rgba(150, 106, 87, 0.24);\n  border-radius: 18px;\n  padding: 1.5rem 1.3rem;\n}\n\n.cart-summary-panel h2 {\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 2.5rem;\n  margin-bottom: 1.2rem;\n  color: #332725;\n}\n\n.summary-row,\n.summary-total {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  font-size: 1rem;\n  padding: 0.7rem 0;\n  color: #504544;\n}\n\n.summary-row strong,\n.summary-total strong {\n  font-size: 1.1rem;\n  color: #2b2422;\n}\n\n.shipping-note {\n  font-size: 0.98rem;\n  line-height: 1.7;\n  color: #5f4c49;\n  padding-top: 0.9rem;\n  border-top: 1px solid rgba(95, 76, 73, 0.2);\n  margin: 0.8rem 0 1.3rem;\n}\n\n.summary-total {\n  border-top: 1px solid rgba(95, 76, 73, 0.2);\n  padding-top: 1rem;\n  margin-top: 0.5rem;\n}\n\n.summary-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.8rem;\n  margin-top: 1.4rem;\n}\n\n.summary-actions > button {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n}\n\n.checkout-button {\n  border-radius: 14px;\n  min-width: 0;\n  width: 100%;\n}\n\n.summary-whatsapp {\n  width: 100%;\n  min-width: 0;\n  background: #ecf8ef;\n  border-color: #8bc59b;\n  color: #2c7d46;\n  border-radius: 14px;\n}\n\n.floating-whatsapp-btn {\n  position: fixed;\n  right: 28px;\n  bottom: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.8rem;\n  background: #22a94d;\n  border: none;\n  color: #ffffff;\n  padding: 0.95rem 1.5rem 0.95rem 1rem;\n  border-radius: 999px;\n  box-shadow: 0 12px 24px rgba(34, 169, 77, 0.3);\n  font-size: 1.05rem;\n  font-weight: 600;\n  cursor: pointer;\n  z-index: 1200;\n}\n\n.floating-whatsapp-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.floating-whatsapp-icon svg {\n  width: 1.45rem;\n  height: 1.45rem;\n}\n\n.empty-cart-state {\n  background: #f9f4f2;\n  border: 1px solid rgba(150, 106, 87, 0.24);\n  border-radius: 18px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  color: #594f4c;\n}\n\n@media (max-width: 900px) {\n  .product-detail-page {\n    grid-template-columns: 1fr;\n  }\n\n  .main-product-image {\n    height: 460px;\n  }\n\n  .cart-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .navbar-container {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .brand-block {\n    grid-column: 1;\n    grid-row: 1;\n    min-width: 0;\n  }\n\n  .brand-name {\n    font-size: 2rem;\n  }\n\n  .mobile-nav-toggle {\n    grid-column: 2;\n    grid-row: 1;\n    display: inline-grid;\n    place-items: center;\n    width: 2.75rem;\n    height: 2.75rem;\n    border: 1px solid rgba(131, 93, 104, 0.25);\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.7);\n    color: #3f2b21;\n    font-size: 1.35rem;\n    line-height: 1;\n  }\n\n  .nav-menu {\n    display: none;\n    grid-column: 1 / -1;\n    grid-row: 2;\n    width: 100%;\n    min-width: 0;\n    flex: none;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.2rem;\n    padding-top: 0.45rem;\n    border-top: 1px solid rgba(131, 93, 104, 0.18);\n  }\n\n  .nav-menu.mobile-open {\n    display: flex;\n  }\n\n  .nav-item {\n    width: 100%;\n    padding: 0.35rem 0;\n  }\n\n  .nav-disclosure {\n    width: 100%;\n    min-height: 2.6rem;\n    cursor: pointer;\n  }\n\n  .nav-dropdown,\n  .nav-menu .nav-item .nav-dropdown {\n    position: static;\n    display: none;\n    min-width: 0;\n    width: 100%;\n    margin-top: 0.25rem;\n    padding: 0.65rem 0 0.4rem;\n    border: 0;\n    border-radius: 0;\n    background: rgba(255, 255, 255, 0.45);\n    box-shadow: none;\n    opacity: 1;\n    visibility: visible;\n    transform: none;\n  }\n\n  .nav-item.expanded .nav-dropdown {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.75rem;\n  }\n\n  .nav-menu .nav-item .nav-dropdown.mega-dropdown {\n    left: auto;\n    transform: none;\n  }\n\n  .nav-actions {\n    position: static;\n    align-self: flex-start;\n    margin-top: 0.2rem;\n  }\n}\n\n/* New editorial homepage. Navigation above remains shared with the existing app. */\n.new-home {\n  --ink: #211a16;\n  --muted: #55433e;\n  --rose: #94452c;\n  --rose-dark: #793019;\n  --blush: #fff1eb;\n  --cream: #fff8f6;\n  --surface: #faebe4;\n  --surface-high: #f4e5df;\n  --sage: #536251;\n  font-family: 'Plus Jakarta Sans', sans-serif;\n  background: var(--cream);\n  color: var(--ink);\n}\n\n.announcement-bar {\n  overflow: hidden;\n  background: var(--rose);\n  color: #fff7f0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  position: relative;\n}\n\n.announcement-bar::before,\n.announcement-bar::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 4rem;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.announcement-bar::before {\n  left: 0;\n  background: linear-gradient(90deg, var(--rose) 0%, rgba(148, 69, 44, 0));\n}\n\n.announcement-bar::after {\n  right: 0;\n  background: linear-gradient(270deg, var(--rose) 0%, rgba(148, 69, 44, 0));\n}\n\n.announcement-track {\n  display: inline-flex;\n  align-items: center;\n  gap: 2.25rem;\n  white-space: nowrap;\n  min-width: max-content;\n  padding: 0.7rem 1rem;\n  animation: announcement-marquee 32s linear infinite;\n}\n\n.announcement-track span {\n  display: inline-block;\n  opacity: 0.98;\n}\n\n.announcement-track span:nth-child(2n) {\n  text-decoration: underline;\n}\n\n@keyframes announcement-marquee {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n.home-band { width: 100%; }\n.new-hero { display: grid; grid-template-columns: minmax(0, 0.9fr) minmax(420px, 1.1fr); gap: clamp(2rem, 5vw, 6rem); align-items: center; padding: clamp(3rem, 7vw, 7rem) max(5vw, 1.25rem); background: linear-gradient(180deg, var(--blush), var(--cream)); border-bottom: 1px solid rgba(136, 114, 108, 0.2); }\n.new-hero-copy { max-width: 600px; margin-left: auto; }\n.new-kicker { display: inline-block; color: var(--rose); font-size: 0.68rem; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; }\n.new-hero h1 { max-width: 680px; margin: 0.8rem 0 1.2rem; font-family: 'Playfair Display', serif; font-size: clamp(3rem, 5.4vw, 5.25rem); font-weight: 500; line-height: 1.05; letter-spacing: 0; }\n.new-hero p { max-width: 510px; color: var(--muted); font-size: 1.05rem; line-height: 1.8; }\n.new-actions { display: flex; flex-wrap: wrap; gap: 0.7rem; margin-top: 2rem; }\n.new-button { border: 1px solid var(--rose); border-radius: 0.5rem; background: var(--rose); color: #fff; padding: 0.85rem 1.15rem; font-size: 0.78rem; font-weight: 700; letter-spacing: 0.02em; transition: background 160ms ease, transform 160ms ease; }\n.new-button:hover { background: var(--rose-dark); transform: translateY(-1px); }\n.new-button span { margin-left: 0.45rem; }\n.new-button-light { background: transparent; color: var(--rose); }\n.hero-proof { display: flex; align-items: center; gap: 0.55rem; margin-top: 1.5rem; color: #8a6b61; font-size: 0.73rem; font-weight: 700; }\n.new-hero-media { position: relative; max-width: 700px; overflow: hidden; aspect-ratio: 1 / 0.92; margin-right: auto; background: #dfc5b9; }\n.new-hero-media > img { width: 100%; height: 100%; object-fit: cover; }\n.hero-product-tag { position: absolute; right: 1rem; bottom: 1rem; left: 1rem; display: grid; grid-template-columns: 1fr auto; gap: 0.2rem 1rem; padding: 0.9rem 1rem; border: 1px solid rgba(136, 114, 108, 0.2); border-radius: 0.75rem; background: rgba(255, 248, 246, 0.95); box-shadow: 0 8px 24px -4px rgba(44, 36, 32, 0.08); }\n.hero-product-tag span { grid-column: 1 / -1; color: var(--rose); font-size: 0.62rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; }\n.hero-product-tag strong { font-family: 'Playfair Display', serif; font-size: 1.05rem; font-weight: 500; }\n.hero-product-tag b { align-self: center; color: var(--rose); font-size: 0.9rem; }\n.trust-strip { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 2rem; padding: 2.5rem max(2.75vw, 1.25rem); background: #fcece5; border-top: 1px solid rgba(136, 114, 108, 0.14); border-bottom: 1px solid rgba(136, 114, 108, 0.14); }\n.trust-item { display: flex; align-items: center; gap: 1.25rem; min-height: 132px; padding: 1.35rem 1.45rem; border: 1px solid rgba(136, 114, 108, 0.1); border-radius: 1.15rem; background: #fff; box-shadow: 0 3px 7px rgba(44, 36, 32, 0.08); }\n.trust-icon { display: grid; place-items: center; flex: 0 0 70px; width: 70px; height: 70px; border-radius: 1rem; color: #91432e; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 2rem; font-weight: 700; line-height: 1; }\n.trust-item-fit .trust-icon { background: #ffd9cd; }\n.trust-item-fabric .trust-icon { background: #d7e8d1; color: #536251; }\n.trust-item-delivery .trust-icon { background: #ffb29c; color: #803a25; }\n.trust-item-support .trust-icon { background: #eee4e0; color: #6f625e; }\n.trust-item strong, .service-row strong { display: block; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 1.05rem; font-weight: 700; line-height: 1.35; }\n.trust-item small, .service-row small { display: block; max-width: 190px; margin-top: 0.25rem; color: #604d47; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 0.93rem; line-height: 1.45; }\n.home-section { max-width: 1400px; margin: 0 auto; padding: clamp(3.5rem, 6vw, 6.5rem) max(5vw, 1.25rem); }\n.section-heading { display: flex; align-items: end; justify-content: space-between; gap: 2rem; margin-bottom: 2rem; }\n.section-heading h2 { margin-top: 0.45rem; font-family: 'Playfair Display', serif; font-size: clamp(2rem, 3.6vw, 3.4rem); font-weight: 500; line-height: 1.08; }\n.section-heading p { margin-top: 0.55rem; color: var(--muted); font-size: 0.88rem; }\n.text-button { border: 0; background: transparent; color: var(--rose); font-size: 0.78rem; font-weight: 800; white-space: nowrap; }\n.category-rail { display: grid; grid-template-columns: repeat(6, minmax(120px, 1fr)); gap: 1rem; }\n.category-tile { border: 0; background: transparent; color: var(--ink); text-align: left; }\n.category-tile img { width: 100%; aspect-ratio: 0.78; border-radius: 999px 999px 4px 4px; object-fit: cover; margin-bottom: 0.7rem; }\n.category-tile strong { display: block; font-family: 'Playfair Display', serif; font-size: 1.05rem; font-weight: 600; }\n.category-tile small { display: block; margin-top: 0.2rem; color: var(--muted); font-size: 0.67rem; }\n.product-section { max-width: none; background: var(--blush); border-top: 1px solid rgba(136, 114, 108, 0.16); border-bottom: 1px solid rgba(136, 114, 108, 0.16); }\n.product-section > * { max-width: 1300px; margin-right: auto; margin-left: auto; }\n.new-product-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; }\n.new-product-card { cursor: pointer; padding: 0.75rem; border: 1px solid rgba(136, 114, 108, 0.16); border-radius: 1rem; background: #fff; box-shadow: 0 8px 24px -4px rgba(44, 36, 32, 0.04); transition: transform 180ms ease, box-shadow 180ms ease; }\n.new-product-card:hover { transform: translateY(-2px); box-shadow: 0 12px 28px -6px rgba(44, 36, 32, 0.12); }\n.new-product-image { position: relative; overflow: hidden; aspect-ratio: 0.78; background: #e4d0c5; }\n.new-product-image img { width: 100%; height: 100%; object-fit: cover; transition: transform 280ms ease; }\n.new-product-card:hover .new-product-image img { transform: scale(1.04); }\n.new-product-image > span { position: absolute; top: 0.75rem; left: 0.75rem; padding: 0.3rem 0.5rem; background: #fffaf5; color: var(--rose); font-size: 0.62rem; font-weight: 800; text-transform: uppercase; }\n.new-product-image button { position: absolute; top: 0.65rem; right: 0.65rem; width: 2rem; height: 2rem; border: 0; border-radius: 50%; background: #fffaf5; color: var(--rose); }\n.new-product-info { padding: 0.8rem 0.15rem; }\n.new-product-info small { color: var(--muted); font-size: 0.65rem; text-transform: uppercase; }\n.new-product-info h3 { margin: 0.25rem 0; font-family: 'Playfair Display', serif; font-size: 1.1rem; font-weight: 600; }\n.new-product-info strong { color: var(--rose); font-size: 0.82rem; }\n.bundle-feature { display: grid; grid-template-columns: 1.1fr 0.9fr; align-items: center; gap: clamp(2rem, 6vw, 7rem); background: #fffaf5; }\n.bundle-images { display: grid; grid-template-columns: 1.2fr 0.8fr; gap: 0.7rem; align-items: end; }\n.bundle-images img { width: 100%; height: 360px; object-fit: cover; }\n.bundle-images img + img { height: 250px; }\n.bundle-copy { max-width: 470px; }\n.bundle-copy h2 { margin: 0.6rem 0 1rem; font-family: 'Playfair Display', serif; font-size: clamp(2.1rem, 3.6vw, 3.5rem); font-weight: 500; line-height: 1.05; }\n.bundle-copy p { color: var(--muted); line-height: 1.8; }\n.bundle-copy .new-button { display: block; margin-top: 1.4rem; }\n.bundle-copy small { display: block; margin-top: 1rem; color: var(--muted); font-size: 0.7rem; }\n.moments-section { background: #f7e8df; }\n.centered { justify-content: center; text-align: center; }\n.moment-grid { display: grid; grid-template-columns: 1.4fr 0.6fr; gap: 1rem; max-width: 1100px; margin: auto; }\n.moment-large { position: relative; min-height: 430px; overflow: hidden; background: #cdb1a5; }\n.moment-large img { width: 100%; height: 100%; min-height: 430px; object-fit: cover; }\n.moment-large > div { position: absolute; right: 1rem; bottom: 1rem; left: 1rem; padding: 1rem; background: rgba(255,250,245,0.9); }\n.moment-large small, .moment-note > span { color: var(--rose); font-size: 0.65rem; font-weight: 800; letter-spacing: 0.1em; text-transform: uppercase; }\n.moment-large h3, .moment-note h3 { margin-top: 0.35rem; font-family: 'Playfair Display', serif; font-size: 1.6rem; font-weight: 600; line-height: 1.15; }\n.moment-note { display: flex; flex-direction: column; justify-content: center; padding: 2rem; background: #fffaf5; }\n.moment-note .text-button { align-self: flex-start; margin-top: 2rem; }\n.testimonial-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; }\n.testimonial-grid blockquote { padding: 1.5rem; background: #f8e9e0; }\n.testimonial-grid blockquote > span { color: var(--rose); letter-spacing: 0.15em; }\n.testimonial-grid p { margin: 1.5rem 0; color: var(--muted); font-family: 'Playfair Display', serif; font-size: 1.15rem; line-height: 1.35; }\n.testimonial-grid footer { font-size: 0.78rem; font-weight: 800; }\n.testimonial-grid footer small { display: block; margin-top: 0.25rem; color: var(--muted); font-weight: 500; }\n.offer-section { max-width: 920px; margin-top: 3rem; margin-bottom: 3rem; background: #f8e9e0; text-align: center; }\n.offer-icon { display: grid; place-items: center; width: 2.3rem; height: 2.3rem; margin: 0 auto 1rem; border-radius: 50%; background: #fffaf5; color: var(--rose); }\n.offer-section h2 { margin: 0.55rem 0; font-family: 'Cormorant Garamond', serif; font-size: clamp(2rem, 4vw, 3.5rem); font-weight: 500; }\n.offer-section p { margin-bottom: 1.2rem; color: var(--muted); }\n.service-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1rem; padding: 2rem max(5vw, 1.25rem); background: #fffaf5; }\n.service-row > div { display: flex; gap: 0.7rem; align-items: center; }\n\n.contact-page { max-width: 1180px; margin: 0 auto; padding: 5rem max(5vw, 1.25rem) 7rem; }\n.contact-hero { max-width: 720px; padding-bottom: 3rem; }\n.contact-hero h1 { margin: 0.5rem 0 1rem; font-family: 'Playfair Display', serif; font-size: clamp(2.8rem, 6vw, 5.5rem); font-weight: 500; line-height: 1; }\n.contact-hero > p:last-child { max-width: 580px; color: var(--muted); font-size: 1.05rem; line-height: 1.8; }\n.contact-details-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; gap: 1rem; }\n.contact-detail-card { padding: 2rem; border: 1px solid rgba(136, 114, 108, 0.2); border-radius: 1rem; background: #fffaf7; box-shadow: 0 10px 28px rgba(82, 57, 48, 0.06); }\n.contact-card-kicker { color: var(--rose); font-size: 0.68rem; font-weight: 800; letter-spacing: 0.14em; text-transform: uppercase; }\n.contact-detail-card h2 { margin: 0.7rem 0 1.2rem; font-family: 'Playfair Display', serif; font-size: clamp(1.8rem, 3vw, 2.2rem); font-weight: 500; }\n.contact-detail-card address { color: var(--muted); font-style: normal; line-height: 1.8; }\n.contact-action { display: inline-flex; align-items: center; justify-content: center; margin-top: 1.5rem; padding: 0.75rem 1rem; border: 1px solid var(--rose); border-radius: 0.45rem; color: var(--rose); font-size: 0.82rem; font-weight: 800; text-decoration: none; }\n.contact-action:hover { background: var(--rose); color: #fff; }\n\n.account-page { max-width: 1180px; margin: 0 auto; padding: 4rem max(5vw, 1.25rem) 6rem; }\n.account-header { padding-bottom: 2rem; border-bottom: 1px solid rgba(136, 114, 108, 0.2); }\n.account-header h1 { margin: 0.45rem 0; font-family: 'Playfair Display', serif; font-size: clamp(2.5rem, 5vw, 4.5rem); font-weight: 500; }\n.account-header > p:last-child { color: var(--muted); }\n.account-section { margin-top: 2rem; }\n.account-section h2 { margin-bottom: 0.8rem; font-family: 'Playfair Display', serif; font-size: 2rem; font-weight: 500; }\n.account-section > p { color: var(--muted); line-height: 1.6; }\n.account-contact-form { display: grid; grid-template-columns: minmax(0, 1fr); gap: 1rem; max-width: 760px; padding: 1.35rem; border: 1px solid rgba(136, 114, 108, 0.18); border-radius: 0.9rem; background: rgba(255, 250, 247, 0.78); box-shadow: 0 10px 28px rgba(82, 57, 48, 0.06); }\n.account-contact-form label { display: grid; gap: 0.4rem; color: var(--muted); font-size: 0.78rem; font-weight: 700; }\n.account-contact-form input, .account-contact-form select { width: 100%; min-height: 3.25rem; }\n.account-contact-actions { display: flex; flex-wrap: wrap; gap: 0.65rem; grid-column: 1 / -1; }\n.account-contact-summary { display: grid; grid-template-columns: minmax(0, 1fr); align-items: center; gap: 1.1rem; max-width: 760px; padding: 1.35rem; border: 1px solid rgba(136, 114, 108, 0.18); border-radius: 0.9rem; background: rgba(255, 250, 247, 0.78); box-shadow: 0 10px 28px rgba(82, 57, 48, 0.06); }\n.account-contact-summary span, .account-contact-summary strong { display: block; }\n.account-contact-summary span { color: var(--rose); font-size: 0.65rem; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase; }\n.account-contact-summary strong { display: block; margin-top: 0.35rem; font-size: 0.95rem; }\n.account-contact-summary button { white-space: nowrap; }\n.contact-update-message { grid-column: 1 / -1; color: #3c7a4a; font-size: 0.8rem; }\n.account-order-list { display: grid; gap: 1rem; }\n.account-order { padding: 1.25rem; border: 1px solid rgba(136, 114, 108, 0.2); border-radius: 0.8rem; background: #fffaf7; }\n.account-order-header, .account-order-footer { display: flex; align-items: center; justify-content: space-between; gap: 1rem; }\n.account-order-header { padding-bottom: 1rem; border-bottom: 1px solid rgba(136, 114, 108, 0.16); }\n.account-order-header strong, .account-order-header small { display: block; }\n.account-order-label { display: block; color: var(--rose); font-size: 0.65rem; font-weight: 800; letter-spacing: 0.12em; text-transform: uppercase; }\n.account-order-header small { margin-top: 0.25rem; color: var(--muted); font-size: 0.75rem; }\n.order-status { padding: 0.35rem 0.65rem; border-radius: 999px; background: #f0e5d9; color: #6d5143; font-size: 0.7rem; font-weight: 800; text-transform: capitalize; }\n.order-status-delivered { background: #dcebd8; color: #4d7047; }\n.order-status-cancelled, .order-status-returned { background: #f3dada; color: #8b4444; }\n.account-order-items { display: grid; gap: 0.75rem; padding: 1rem 0; }\n.account-order-item { display: grid; grid-template-columns: 58px 1fr auto; align-items: center; gap: 0.8rem; }\n.account-order-item img, .account-order-image-placeholder { width: 58px; height: 70px; border-radius: 0.35rem; object-fit: cover; background: #ead6d0; }\n.account-order-image-placeholder { display: grid; place-items: center; color: var(--rose); font-family: 'Allura', cursive; font-size: 1.5rem; }\n.account-order-item-info strong, .account-order-item-info span { display: block; }\n.account-order-item-info strong { font-family: 'Playfair Display', serif; font-size: 1.05rem; }\n.account-order-item-info span, .account-order-item b, .account-order-footer { color: var(--muted); font-size: 0.78rem; }\n.account-order-item b, .account-order-footer strong { color: var(--ink); }\n.account-order-footer { padding-top: 0.9rem; border-top: 1px solid rgba(136, 114, 108, 0.16); }\n.field-help { display: block; margin-top: 0.45rem; color: var(--muted); font-size: 0.72rem; line-height: 1.45; }\n.field-help-alert { color: #c43d4f; font-weight: 700; animation: address-alert-flicker 700ms ease-in-out 2; }\n.combo-measurement-notice { margin: 0.8rem 0; color: #c43d4f; font-weight: 800; line-height: 1.45; animation: address-alert-flicker 700ms ease-in-out 6; }\n@keyframes address-alert-flicker {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.18; }\n}\n\n@media (max-width: 900px) {\n  .new-hero, .bundle-feature { grid-template-columns: 1fr; }\n  .new-hero-copy { margin: 0; }\n  .new-hero-media { width: 100%; }\n  .category-rail { display: flex; overflow-x: auto; padding-bottom: 0.7rem; scroll-snap-type: x mandatory; }\n  .category-tile { flex: 0 0 145px; scroll-snap-align: start; }\n  .new-product-grid { grid-template-columns: repeat(2, 1fr); }\n  .bundle-copy { max-width: none; }\n  .service-row { grid-template-columns: repeat(2, 1fr); }\n  .trust-strip { gap: 1rem; padding: 1.5rem 1rem; }\n  .trust-item { gap: 0.75rem; min-height: 110px; padding: 1rem; }\n  .trust-icon { flex-basis: 54px; width: 54px; height: 54px; border-radius: 0.85rem; font-size: 1.55rem; }\n  .trust-item strong { font-size: 0.85rem; }\n  .trust-item small { font-size: 0.72rem; }\n}\n\n@media (max-width: 600px) {\n  .contact-page { padding-top: 3rem; }\n  .contact-details-grid { grid-template-columns: 1fr; }\n  .contact-detail-card { min-height: 0; padding: 1.4rem; }\n  .contact-detail-card h2 { font-size: 1.8rem; }\n  .account-page { padding-top: 2.5rem; }\n  .account-contact-form { grid-template-columns: 1fr; padding: 1rem; }\n  .account-contact-summary { grid-template-columns: 1fr; align-items: start; padding: 1rem; }\n  .account-order { padding: 1rem; }\n  .account-order-header, .account-order-footer { align-items: flex-start; flex-direction: column; }\n  .account-order-item { grid-template-columns: 48px 1fr; }\n  .account-order-item img, .account-order-image-placeholder { width: 48px; height: 58px; }\n  .account-order-item b { grid-column: 2; }\n  .announcement-bar { font-size: 0.62rem; }\n  .announcement-bar span { display: block; margin: 0.2rem 0 0; }\n  .new-hero { padding-top: 3rem; }\n  .new-hero h1 { max-width: 12ch; font-size: 2.5rem; line-height: 1.08; }\n  .new-actions { flex-direction: column; align-items: stretch; }\n  .new-button { width: 100%; }\n  .trust-strip, .testimonial-grid { grid-template-columns: 1fr 1fr; }\n  .trust-strip { gap: 0.7rem; padding: 1rem 0.75rem; }\n  .trust-item { display: block; min-height: 0; padding: 0.9rem; }\n  .trust-icon { width: 48px; height: 48px; margin-bottom: 0.65rem; font-size: 1.35rem; }\n  .trust-item strong { font-size: 0.78rem; }\n  .trust-item small { font-size: 0.67rem; }\n  .section-heading { align-items: flex-start; flex-direction: column; gap: 1rem; }\n  .new-product-grid { gap: 0.7rem; }\n  .new-product-info h3 { font-size: 1.05rem; }\n  .bundle-images img { height: 240px; }\n  .bundle-images img + img { height: 170px; }\n  .moment-grid { grid-template-columns: 1fr; }\n  .moment-large, .moment-large img { min-height: 320px; }\n  .service-row { grid-template-columns: 1fr; }\n\n  .shop-page { width: min(100% - 1.25rem, 1240px); padding: 1.5rem 0 3rem; }\n  .shop-header { align-items: stretch; flex-direction: column; }\n  .shop-header > div:last-child { display: grid !important; grid-template-columns: 1fr; width: 100%; }\n  .shop-header select { width: 100%; min-height: 2.8rem; }\n  .category-chips { margin: 0 -0.625rem; padding: 0 0.625rem 1rem; }\n  .product-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.65rem; }\n  .product-image-wrap { height: auto; aspect-ratio: 0.78; }\n  .product-body { padding: 0.75rem; }\n  .product-card h3 { font-size: 0.95rem; line-height: 1.3; }\n  .product-description { min-height: 0; }\n\n  .floating-whatsapp-btn {\n    right: 1rem;\n    bottom: max(1rem, env(safe-area-inset-bottom));\n    width: 3.5rem;\n    height: 3.5rem;\n    padding: 0;\n  }\n\n  .floating-whatsapp-btn > span:last-child { display: none; }\n  .floating-whatsapp-icon { width: 2.5rem; height: 2.5rem; background: transparent; }\n  .floating-whatsapp-icon svg { width: 2rem; height: 2rem; }\n}\n\n@media (max-width: 640px) {\n  .hero-banner {\n    padding: 1.5rem;\n    min-height: 360px;\n  }\n\n  .hero-content {\n    padding: 1.2rem;\n    max-width: 100%;\n  }\n\n  .hero-content h1 {\n    font-size: clamp(2rem, 8vw, 3.2rem);\n  }\n\n  .feature-list {\n    grid-template-columns: 1fr;\n  }\n\n  .cta-row {\n    flex-direction: column;\n  }\n\n  .primary-btn,\n  .secondary-btn {\n    width: 100%;\n  }\n\n  .auth-card {\n    padding: 1.6rem 1.1rem;\n  }\n\n  .auth-card h1 {\n    font-size: 3rem;\n  }\n\n  .cart-item-card {\n    grid-template-columns: 1fr;\n  }\n\n  .cart-item-card img {\n    width: 100%;\n    height: 240px;\n  }\n\n  .date-fields,\n  .summary-actions {\n    grid-template-columns: 1fr;\n  }\n\n  .navbar {\n    padding: 0.8rem 0 0.7rem;\n  }\n\n  .navbar-container {\n    padding: 0 0.8rem;\n  }\n\n  .auth-wrapper { margin: 0.75rem auto; padding: 0.75rem 0.65rem 2.5rem; }\n  .auth-card { border-radius: 18px; padding: 1.5rem 1rem 1.35rem; }\n  .auth-card h1 { font-size: 2.7rem; }\n  .auth-card > p { font-size: 0.95rem; line-height: 1.45; }\n  .auth-toggle { gap: 0.35rem; margin-bottom: 1rem; }\n  .auth-toggle button { padding: 0.75rem 0.5rem; font-size: 0.95rem; }\n  .auth-form label { font-size: 0.92rem; margin-top: 0.8rem; }\n  .auth-form input, .auth-form select { min-height: 3rem; padding: 0.8rem; font-size: 0.95rem; }\n  .phone-input-group { grid-template-columns: minmax(7rem, 0.8fr) minmax(0, 1fr); }\n  .back-home-link { margin-top: 1.2rem; font-size: 0.9rem; }\n\n  .brand-name {\n    font-size: 1.8rem;\n  }\n\n  .nav-menu {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.3rem;\n  }\n\n  .nav-item {\n    width: 100%;\n    font-size: 1.1rem;\n    padding: 0.15rem 0;\n  }\n\n  .nav-home > a {\n    display: block;\n    width: 100%;\n    max-width: 180px;\n  }\n\n  .nav-dropdown,\n  .nav-menu .nav-item .nav-dropdown {\n    position: static;\n    opacity: 0;\n    visibility: hidden;\n    transform: none;\n    box-shadow: none;\n    border: none;\n    background: transparent;\n    margin-top: 0.3rem;\n    padding: 0 0 0.2rem 0;\n    left: auto;\n    display: none;\n  }\n\n  .nav-item.expanded .nav-dropdown {\n    opacity: 1;\n    visibility: visible;\n    display: block;\n  }\n\n  .mega-dropdown {\n    min-width: 0;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    padding: 0;\n  }\n\n  .dropdown-column {\n    min-width: 0;\n  }\n\n  .dropdown-column h4,\n  .dropdown-card h4 {\n    margin-bottom: 0.25rem;\n  }\n\n  .nav-phone {\n    display: none;\n  }\n\n  .nav-actions {\n    position: static;\n    align-self: flex-end;\n    margin-top: 0.35rem;\n  }\n\n  .checkout-page {\n    width: min(100% - 1.25rem, 760px);\n    padding-top: 1.5rem;\n  }\n\n  .checkout-form {\n    padding: 1.15rem;\n  }\n\n  .checkout-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .checkout-grid > label:last-child:nth-child(3) {\n    grid-column: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
